export const QuizAnswersEnglish = {
    //DATA STRUCTURES 
    "4": "4",
    "2": "2",
    "30": "30",
    "50": "50",
    "10": "10",
    "20": "20",
    "1": "1",
    "Null": "Null",
    "Random Probing": "Random Probing",
    "15": "15",
    "Δεν μπορεί να χρησιμοποιηθεί σε μεγάλες λίστες λόγω χρονικής πολυπλοκότητας": "Cannot be used in large lists due to time complexity",
    "Απαιτεί ξεχωριστούς πίνακες για κάθε κόμβο": "Requires separate arrays for each node",
    "Χρησιμοποιεί επιπλέον χώρο στη στοίβα κλήσεων": "Uses extra space in the call stack",
    "Δεν επιστρέφει ποτέ NULL": "Never returns NULL",
    "Εξερευνά κάθε κλάδο ως το τέλος": "Explores each branch to the end",
    "5": "5",
    "n": "n",
    "2n": "2n",
    "Εξαρτάται από τον τύπο των στοιχείων": "It depends on the type of data",
    "n + 1": "n + 1",
    "NULL": "NULL",
    "Το μέγεθος του πίνακα": "The size of the array",
    "Την αρχική τιμή κάθε στοιχείου": "The initial value of each element",
    "Το άθροισμα των στοιχείων": "The sum of the elements",
    "Τον αριθμό των πράξεων που θα γίνουν": "The number of operations to be performed",
    "Δεν έχει σημασία": "It does not matter",
    "Η λίστα είναι κενή": "The list is empty",
    "data(1)": "data(1)",
    "data.first()": "data.first()",
    "data[0]": "data[0]",
    "Αύξηση της ταχύτητας": "Increase in speed",
    "Ασφαλέστερη εκτέλεση": "Safer execution",
    "Απενεργοποίηση μεταγλωττιστή": "Deactivation of compiler",
    "Σπατάλη πόρων και πιθανή αποτυχία εκτέλεσης": "Waste of resources and potential execution failure",
    "data.index(0)": "data.index(0)",
    "Όλα τα παραπάνω": "All of the above",
    "Ορίζουμε current->next->prev = current->prev": "We set current->next->prev = current->prev",
    "Ορίζουμε current->prev->next = current": "We set current->prev->next = current",
    "Το παιδί του successor παίρνει τη θέση του": "The child of the successor takes its place",
    "i+2": "i+2",
    "2i+2": "2i+2",
    "Διατηρεί τη σειρά": "Maintains the order",
    "Αντικαθιστούμε όλο τον πίνακα": "Replace the entire array",
    "Μετακίνηση στοιχείων δεξιά": "Shift elements right",

    "Αντικατάσταση με μηδενικά": "Replacement with zeros",

    "Μετακίνηση στοιχείων αριστερά": "Shift elements left",
    "Δεν λειτουργεί σε μικρούς πίνακες": "Does not work on small arrays",

    "Απαιτεί αναζήτηση της θέσης": "Requires position lookup",

    "Δεν επιτρέπεται στη C": "Not allowed in C",
    "Για να μην αντικατασταθούν δεδομένα": "So that data is not overwritten",

    "Γιατί είναι πιο γρήγορο": "Because it is faster",
    "O(1)": "O(1)",
    "16": "16",
    "O(log n)": "O(log n)",
    "49": "49",
    "60": "60",
    "90": "90",
    "O(n)": "O(n)",
    "O(n)": "O(n)",

    "O(m)": "O(m)",
    "Διαγώνιο": "Diagonal",
    "Αποθηκεύει στοιχεία με βάση την insertion order": "Stores elements based on insertion order",

    "Επιτρέπει null σε κάθε περίπτωση": "Allows null in every case",
    "Το στοιχείο προστίθεται κανονικά": "The element is added normally",

    "Η μέθοδος επιστρέφει false": "The method returns false",
    "IllegalArgumentException": "IllegalArgumentException",

    "ClassCastException": "ClassCastException",

    "ArrayIndexOutOfBoundsException": "ArrayIndexOutOfBoundsException",
    "Χρησιμοποιεί index": "Uses index",

    "Δεν υποστηρίζει διαγραφή": "Does not support deletion",
    "Θα προστεθούν και τα δύο": "Both will be added",
    "Χρησιμοποιείται μόνο αν δεν υπάρχει compareTo()": "Is only used if there is no compareTo()",

    "Χρησιμοποιείται μόνο για διπλότυπα": "Is only used for duplicates",

    "Είναι υποχρεωτικό να είναι static": "It is mandatory for it to be static",

    "Παρακάμπτει τη φυσική σειρά": "Overrides the natural order",
    "Θα απορριφθεί το δεύτερο": "The second will be rejected",

    "Θα προκαλέσει εξαίρεση": "It will cause an exception",

    "Το TreeSet θα τα αποθηκεύσει ως ίδια και θα τα συγχωνεύσει": "The TreeSet will store them as identical and merge them",
    "Πρέπει να διατηρηθούν οι ιδιότητες του Red-Black Tree": "The properties of the Red-Black Tree must be maintained",

    "Η λειτουργία είναι O(n)": "The operation is O(n)",
    "NullPointerException": "NullPointerException",
    "Προκαλείται NullPointerException": "A NullPointerException is thrown",

    "Το στοιχείο αγνοείται": "The element is ignored",
    "Χρησιμοποιεί λογική σύγκρισης για την ταξινόμηση": "Uses comparison logic for sorting",

    "Επιτρέπει διπλότυπα στοιχεία": "Allows duplicate elements",
    "Συμμετρικό": "Symmetric",
    "Χρησιμοποιεί πολύ λίγη μνήμη": "Uses very little memory",

    "Εκτελείται πολύ αργά (O(n))": "Executes very slowly (O(n))",

    "Απαιτεί χρόνο Ο(logn)": "Requires O(logn) time",

    "Δεν αυξάνει το capacity": "Does not increase the capacity",
    "Άνω τριγωνικό": "Upper triangular",

    "Στοχαστικό": "Stochastic",
    "O(n + m)": "O(n + m)",
    "mid // n": "mid // n",
    "O(n × m)": "O(n × m)",
    "n – 1": "n - 1",
    "O(n²)": "O(n²)",
    "Τον εαυτό της": "Itself",
    "Για να ακολουθήσει φυσική σειρά": "To follow a natural order",
    "1 έως 4 για τις γραμμές, 1 έως 5 για τις στήλες": "1 to 4 for the rows, 1 to 5 for the columns",
    "Για λόγους μνήμης cache": "For cache memory reasons",
    "Προκαλεί segmentation fault": "Causes segmentation fault",
    "Καμία μεταβολή": "No change",
    "Κάνουμε μετατόπιση δεξιά από το σημείο": "We shift right from the point",

    "Καλούμε συνάρτηση αναδιάταξης": "We call a rearrangement function",

    "Διαγράφουμε και μετά εισάγουμε": "We delete and then insert",
    "Απλώς αδειάζει τη θέση": "Just clears the position",

    "Μετακινεί όλα τα στοιχεία δεξιά": "Moves all elements to the right",

    "Αυξάνει το μέγεθος του πίνακα": "Increases the size of the array",
    "Διαγραφή της ρίζας": "Deletion of the root",
    "Αναδιάταξη": "Rearrangement",
    "9": "9",
    "Χρησιμοποιεί δείκτες front και rear": "Uses front and rear pointers",
    "Έχει σταθερό μέγεθος στη μορφή array": "Has a fixed size in array form",
    "Διαγράφει τα στοιχεία από το τέλος": "Deletes elements from the end (Incorrect for Queue)",
    "Μπορεί να γίνει κυκλική επιστροφή στη θέση 0": "Can wrap around to position 0",
    "Όταν front == rear": "When front == rear",
    "Όταν rear + 1 == n": "When rear + 1 == n",
    "Όταν (rear + 1) % n == front": "When (rear + 1) % n == front", // Queue Full Condition (one empty slot)
    "Όταν rear == front - 1": "When rear == front - 1",
    "0": "0",
    "-1": "-1",
    "n": "n",
    "Δεν έχουν προκαθορισμένη τιμή": "They do not have a predetermined value",
    "Προστίθεται νέο στοιχείο": "A new element is added",
    "Τίποτα": "Nothing",
    "Παρουσιάζεται underflow": "Underflow occurs",
    "Rear μετακινείται": "Rear moves",
    "Θέλουμε συνεχώς να εισάγουμε στοιχεία χωρίς διαγραφή": "We constantly want to insert elements without deletion",
    "Θέλουμε ανακύκλωση διαθέσιμου χώρου": "We want to recycle available space (Circular Queue)",
    "Δεν γνωρίζουμε τον αριθμό των στοιχείων": "We do not know the number of elements",
    "Θέλουμε στοίβα τύπου LIFO": "We want an LIFO type stack",
    "Μεταβλητό μέγεθος": "Variable size",
    "Ευκολότερη διαχείριση δεικτών": "Easier pointer management",
    "Δυναμική ανάπτυξη": "Dynamic growth",
    "Χρήση επιπλέον μνήμης για δείκτες": "Use of extra memory for pointers",
    "dequeue()": "dequeue()",
    "insert()": "insert()",
    "peek()": "peek()",
    "remove()": "remove()",
    "Είναι πάντα κενός": "It is always empty",
    "Συνδέεται με τον πρώτο": "It connects to the first",
    "Δεν έχει δείκτη επόμενου": "It does not have a next pointer",
    "Συνδέεται με NULL": "It connects to NULL",
    "rear == size - 1": "rear == size - 1",
    "front == -1": "front == -1",
    "rear = rear + 1": "rear = rear + 1",
    "rear = (rear + 1) % size": "rear = (rear + 1) % size",
    "rear = rear % size + 1": "rear = rear % size + 1",
    "rear++ % size": "rear++ % size",
    "5": "5",
    "1": "1",
    "3": "3",
    "Η ουρά είναι άδεια": "The queue is empty",
    "Η ουρά είναι γεμάτη": "The queue is full",
    "Η ουρά έχει 1 στοιχείο": "The queue has 1 element",
    "Η ουρά έχει 2 στοιχεία": "The queue has 2 elements",
    "Τίποτα ή μήνυμα επιτυχίας": "Nothing or success message",
    "Τον δείκτη front": "The front pointer",
    "Το τελευταίο στοιχείο": "The last element",
    "Το μέγεθος της ουράς": "The size of the queue",
    "Στην πλήρη, το rear είναι πάντα μεγαλύτερο από το front": "In the full queue, rear is always greater than front",
    "Στην άδεια, το front και το rear είναι ίσα με -1": "In the empty queue, front and rear are equal to -1",
    "Στην πλήρη, το rear + 1 είναι ίσο με το front": "In the full queue, rear + 1 is equal to front",
    "Στην άδεια, το rear είναι ίσο με το front": "In the empty queue, rear is equal to front",
    "4": "4",
    "6": "6",
    "Εξαρτάται από τον δείκτη rear": "It depends on the rear pointer",
    "Προσθέτει στοιχείο στην ουρά": "Adds an element to the queue (enqueue)",
    "Επιστρέφει το πιο πρόσφατο στοιχείο": "Returns the most recent element (Stack top)",
    "Αφαιρεί το πρώτο στοιχείο της ουράς": "Removes the first element of the queue (dequeue)",
    "Αδειάζει ολόκληρη την ουρά": "Empties the entire queue",
    "front += 1": "front += 1",
    "front = (front + 1) % size": "front = (front + 1) % size", // Circular Queue Dequeue
    "front = rear": "front = rear",
    "Δεν αλλάζει": "Does not change",
    "Διαγραφή στοιχείου": "Deletion of an element",
    "Κυκλική ενημέρωση των δεικτών": "Circular update of the pointers",
    "Εύρεση του rear": "Finding the rear",
    "Ταχύτητα υπολογισμού": "Calculation speed",
    "Διαγράφει το στοιχείο": "Deletes the element",
    "Βρίσκει αν ένα στοιχείο υπάρχει": "Finds if an element exists",
    "Εισάγει νέο στοιχείο": "Inserts a new element",
    "Αναδιατάσσει την ουρά": "Reorders the queue",
    "Συνεχίζουμε για πάντα": "We continue forever",
    "Επαναλαμβάνουμε από την αρχή": "We repeat from the beginning",
    "Σταματάμε την αναζήτηση": "We stop the search",
    "Διπλασιάζουμε το μέγεθο": "We double the size",
    "i = i + 1": "i = i + 1",
    "i = (i - 1) % size": "i = (i - 1) % size",
    "i = (i + 1) % size": "i = (i + 1) % size", // Circular traversal
    "i = rear - 1": "i = rear - 1",
    "Αν η ουρά είναι γεμάτη": "If the queue is full",
    "Αν η ουρά είναι άδεια": "If the queue is empty",
    "Αν ο δείκτης είναι μηδέν": "If the pointer is zero",
    "Αν η ουρά περιέχει άρτιους αριθμούς": "If the queue contains even numbers",
    "Όταν φτάσουμε στο front": "When we reach front",
    "Όταν το στοιχείο βρεθεί ή φτάσουμε στο rear": "When the element is found or we reach rear",
    "Όταν κάνουμε size βήματα": "When we take size steps",
    "Ποτέ": "Never",
    "O(1)": "O(1)",
    "O(log n)": "O(log n)",
    "O(n)": "O(n)",
    "O(n²)": "O(n²)",
    "Όταν ο rear < front": "When rear < front",
    "Όταν βρούμε το στοιχείο": "When we find the element",
    "Όταν η ουρά έχει μέγεθος 1": "When the queue has size 1",
    "Την αρχική θέση": "The starting position",
    "True/False ή τη θέση του στοιχείου": "True/False or the position of the element",
    "Πάντα το rear": "Always the rear",
    "Να είναι front = rear": "To be front = rear",
    "Να γεμίσει ο πίνακας": "To fill the array",
    "Να επανέλθουν front και rear σε -1": "To reset front and rear to -1",
    "Να είναι το rear = 0": "To be rear = 0",
    "Για να εμφανιστεί το πρώτο στοιχείο": "To display the first element",
    "Για να αποφύγουμε underflow": "To avoid underflow",
    "Για να προσθέσουμε νέα δεδομένα": "To add new data",
    "Για να γεμίσουμε την ουρά": "To fill the queue",
    "(front + 1) % size == rear": "(front + 1) % size == rear",
    "(front + 1) % size == front": "(front + 1) % size == front",
    "(rear + 1) % size == size": "(rear + 1) % size == size",
    "Το front είναι μεγαλύτερο από το rear": "Front is greater than rear",
    "Υπάρχουν κενές θέσεις στην ουρά": "There are empty slots in the queue",
    "Το peek() διαγράφει και επιστρέφει στοιχείο": "peek() deletes and returns an element",
    "Το dequeue() απλώς βλέπει το στοιχείο": "dequeue() just views the element",
    "Το peek() επιστρέφει χωρίς διαγραφή": "peek() returns without deletion",
    "Δεν υπάρχει διαφορά": "There is no difference",
    "FIFO – First In, First Out": "FIFO – First In, First Out",
    "FILO – First In, Last Out": "FILO – First In, Last Out",
    "LIFO – Last In, First Out": "LIFO – Last In, First Out",
    "LILO – Last In, Last Out": "LILO – Last In, Last Out",
    "Πίνακας δυναμικού μεγέθους": "Dynamic size array",
    "Μονοδιάστατος πίνακας": "One-dimensional array",
    "Συνδεδεμένη λίστα": "Linked list",
    "Δυαδικό δέντρο": "Binary tree",
    "Δυναμική μνήμη (heap)": "Dynamic memory (heap)",
    "Μνήμη cache": "Cache memory",
    "Εικονική μνήμη": "Virtual memory",
    "Στατική μνήμη": "Static memory",
    "Επειδή επιτρέπει πολύπλοκες λειτουργίες": "Because it allows complex operations",
    "Επειδή δεν απαιτεί διαχείριση δεικτών": "Because it does not require pointer management",
    "Επειδή δεν χρειάζεται πίνακα": "Because it does not need an array",
    "Επειδή έχει μεταβλητό μέγεθος": "Because it has variable size",
    "Να γνωρίζουμε προκαταβολικά το μέγιστο μέγεθος": "To know the maximum size in advance",
    "Να έχει πάντα άρτιο αριθμό στοιχείων": "To always have an even number of elements",
    "Να περιέχει μόνο αριθμούς": "To contain only numbers",
    "Να χρησιμοποιεί δύο δείκτες": "To use two pointers",
    "Ιεραρχική": "Hierarchical",
    "Δενδρική": "Tree-like",
    "Κυκλική": "Circular",
    "Γραμμική": "Linear",
    "Διαχείριση βάσεων δεδομένων": "Database management",
    "Μετατροπή εκφράσεων infix → postfix": "Conversion of expressions infix → postfix",
    "Ταξινόμηση με quicksort": "Sorting with quicksort",
    "Δημιουργία πινάκων ακεραίων": "Creation of integer arrays",
    "Ο γράφος είναι DAG": "The graph is a DAG (Directed Acyclic Graph)",
    "Ο γράφος παραμένει DAG": "The graph remains Dag",
    "Δημιουργείται κύκλος": "A cycle is created",
    "Δεν αλλάζει τίποτα": "Nothing changes",
    "Μια ακμή (A–B) είναι διαφορετική από την ακμή (B–A)": "An edge (A-B) is different from edge (B-A)",
    "Ο γράφος γίνεται weighted": "The graph becomes weighted",
    "Ο γράφος είναι strongly connected": "The graph is strongly connected",
    "Ο γράφος δεν είναι συνεκτικός": "The graph is not connected",
    "Ο γράφος είναι undirected": "The graph is undirected",
    "Σε λειτουργικά συστήματα με ανάγκη για εναλλαγή διεργασιών": "In operating systems requiring process switching (Call Stack)",
    "Σε περιβάλλοντα με απρόβλεπτες απαιτήσεις μνήμης": "In environments with unpredictable memory requirements",
    "Σε ενσωματωμένα συστήματα": "In embedded systems",
    "Σε web εφαρμογές με βάσεις δεδομένων": "In web applications with databases",
    "Η στοίβα ακολουθεί την αρχή FIFO": "The stack follows the FIFO principle",
    "Το τελευταίο στοιχείο εισάγεται και πρώτο αφαιρείται": "The last element is inserted and the first is removed (LIFO)",
    "Η στοίβα χρησιμοποιεί δύο δείκτες": "The stack uses two pointers",
    "Τα στοιχεία διαγράφονται τυχαία": "Elements are deleted randomly",
    "Εισαγωγή → Έλεγχος → Αύξηση δείκτη": "Insertion → Check → Increment pointer",
    "Αύξηση δείκτη → Εισαγωγή → Έλεγχος": "Increment pointer → Insertion → Check",
    "Έλεγχος → Αύξηση δείκτη → Εισαγωγή": "Check → Increment pointer → Insertion",
    "Εισαγωγή → Μείωση δείκτη → Έλεγχος": "Insertion → Decrement pointer → Check",
    "9": "9",
    "Μικρότερη από 10": "Smaller than 10",
    "Μικρότερη από 9": "Smaller than 9",
    "Τοποθέτηση στοιχείου σε γεμάτη στοίβα": "Placing an element on a full stack (Overflow)",
    "Αφαίρεση από άδεια στοίβα": "Removal from an empty stack (Underflow)",
    "Εισαγωγή χωρίς έλεγχο": "Insertion without checking",
    "Λανθασμένη αρχικοποίηση": "Incorrect initialization",
    "Deleted: 2": "Deleted: 2",
    "Deleted: 99": "Deleted: 99",
    "Deleted: -1": "Deleted: -1",
    "Deleted: stack[1]": "Deleted: stack[1]",
    "int array[5] = {1, 2, 3, 4, 5};": "int array[5] = {1, 2, 3, 4, 5};",
    "int array[2][3] = {{1,2,3}, {4,5,6}};": "int array[2][3] = {{1,2,3}, {4,5,6}}; (Correct C/C++ 2D initialization)",
    "int array[] = { {1,2}, {3,4} };": "int array[] = { {1,2}, {3,4} };",
    "array = [[1,2],[3,4]]": "array = [[1,2],[3,4]]",
    "Πίνακας γειτνίασης σε γράφο": "Adjacency matrix in a graph",
    "Λίστα επαφών με διαφορετικά πεδία ανά επαφή": "Contact list with different fields per contact",
    "Ουρά αναμονής": "Waiting queue",
    "0 έως 4 για τις γραμμές, 0 έως 5 για τις στήλες": "0 to 4 for rows, 0 to 5 for columns",
    "0 έως 3 για τις γραμμές, 0 έως 4 για τις στήλες": "0 to 3 for rows, 0 to 4 for columns (4 rows, 5 columns)",
    "1 έως 3 για τις γραμμές, 1 έως 4 για τις στήλες": "1 to 3 for rows, 1 to 4 for columns",
    "int a[3][4];": "int a[3][4];",
    "int c[2][2] = {{5,6}, {7,8}};": "int c[2][2] = {{5,6}, {7,8}};",
    "int d[2][3] = {1, 2, 3, 4, 5, 6};": "int d[2][3] = {1, 2, 3, 4, 5, 6};",
    "int b[][] = {{1, 2}, {3, 4}};": "int b[][] = {{1, 2}, {3, 4}}; (Incorrect C/C++ syntax)",
    "FIFO εξυπηρέτηση": "FIFO service",
    "Εξυπηρέτηση με βάση την προτεραιότητα": "Service based on priority",
    "Στοίβα (LIFO)": "Stack (LIFO)",
    "Αναζήτηση με δυαδική ταξινόμηση": "Search with binary sorting",
    "Πίνακας": "Array",
    "Δυαδικός σωρός (heap)": "Binary heap",
    "Hash table": "Hash table",
    "Δυαδική αναζήτηση": "Binary search",
    "Δίκτυα": "Networks",
    "Εξομοιώσεις": "Simulations",
    "Αλγόριθμοι εύρεσης βέλτιστων μονοπατιών": "Optimal path finding algorithms",
    "Αφαίρεση του στοιχείου υψηλότερης προτεραιότητας": "Removal of the highest priority element",
    "Έλεγχος κενότητας": "Emptiness check",
    "Ενημέρωση δείκτη": "Pointer update",
    "Τυχαία εξυπηρέτηση": "Random service",
    "Χρονική κατανομή αιτήσεων": "Time distribution of requests",
    "Εξυπηρέτηση με βάση σπουδαιότητα αιτημάτων": "Service based on importance of requests",
    "Αναζήτηση στοιχείων": "Searching for elements",
    "Σύνθεση δυαδικού δέντρου": "Composition of a binary tree",
    "Ενημέρωση της θέσης τους": "Updating their position",
    "Σειριακή διαγραφή": "Sequential deletion",
    "Θα εκτελεστεί τυχαία μία από τις δύο": "One of the two will be executed randomly",
    "Θα εκτελεστεί πρώτα αυτή με μικρότερο PID": "The one with the smallest PID will be executed first",
    "Θα εκτελεστεί πάντα αυτή που εισήχθη πρώτη": "The one that was inserted first will always be executed (FIFO tie-breaker)",
    "Θα εκτελεστεί αυτή που εισήχθη τελευταία": "The one that was inserted last will be executed",
    "Προτεραιότητα 0": "Priority 0",
    "Σφάλμα στο rear": "Error in rear",
    "Προσθήκη στο τέλος": "Addition at the end",
    "Υπερχείλιση": "Overflow",
    "Διαγραφή front": "Deletion of front",
    "Το πρώτο": "The first",
    "Το μεσαίο": "The middle",
    "Το πιο πρόσφατο": "The most recent",
    "Εκείνο με τη μεγαλύτερη προτεραιότητα": "The one with the highest priority",
    "Χρησιμοποιεί recursion": "Uses recursion",
    "Αποθηκεύει λίστες": "Stores lists",
    "Αξιοποιεί πλήρως τον πίνακα": "Fully utilizes the array (Completeness)",
    "Προσφέρει ταξινόμηση": "Offers sorting",
    "Infinite loop": "Infinite loop",
    "Απώλεια δεδομένων": "Data loss",
    "Εκτύπωση λαθών": "Printing errors",
    "Μηδενισμός ουράς": "Queue reset to zero",
    "Επαναφορά δείκτη": "Pointer reset",
    "Κενή λίστα": "Empty list",
    "Αναδιάταξη με heapify": "Reordering with heapify",
    "Push στοιχείου": "Push element",
    "rear == size - 1": "rear == size - 1 (Linear array full)",
    "rear == front && front == 0": "rear == front && front == 0",
    "size == 0": "size == 0",
    "Σε heap, αφαιρείται πάντα η ρίζα": "In heap, the root is always removed",
    "Σε λίστα, έχει κόστος O(1) γιατί σαρώνει μόνο την αρχή": "In list, it costs O(1) because it only scans the beginning",
    "Σε πίνακα απαιτεί αναζήτηση του στοιχείου με κατάλληλη προτεραιότητα": "In array, it requires searching for the element with appropriate priority",
    "Σε heap η λειτουργία είναι αποδοτική λόγω heapify": "In heap, the operation is efficient due to heapify",
    "Push": "Push",
    "Sort": "Sort",
    "Heapify": "Heapify",
    "Rebuild του heap από την αρχή": "Rebuild the heap from the beginning",
    "Η προτεραιότητα καθορίζει πότε θα εξυπηρετηθεί το στοιχείο": "Priority determines when the element will be served",
    "Σε heap, το στοιχείο τοποθετείται στην κατάλληλη θέση": "In heap, the element is placed in the appropriate position",
    "Σε πίνακα τοποθετείται στο τέλος": "In array, it is placed at the end",
    "Η σειρά εισαγωγής υπερισχύει της προτεραιότητας": "Insertion order overrides priority",
    "Το α διαγράφεται": "α is deleted",
    "Το α μετακινείται στη ρίζα (heapify-up)": "α moves to the root (heapify-up)",
    "Το α μετακινείται στο τέλος του heap": "α moves to the end of the heap",
    "Η ουρά γίνεται πίνακας χωρίς δομή heap": "The queue becomes an array without a heap structure",
    "Θα αφαιρεθεί taskA και μετά θα αφαιρεθεί πάλι": "taskA will be removed and then removed again",
    "Η δεύτερη delete() επιστρέφει taskA ξανά": "The second delete() returns taskA again",
    "Θα προκύψει σφάλμα ή κενή απάντηση στη 2η delete()": "An error or empty response will result in the 2nd delete()",
    "Η ουρά θα γίνει stack": "The queue will become a stack",
    "insertAtEnd": "insertAtEnd",
    "enqueue": "enqueue",
    "push": "push",
    "append": "append",
    "Stack is empty": "Stack is empty",
    "Στον παλιό κόμβο με data 12": "To the old node with data 12",
    "Σε null": "To null",
    "Σε νέο κόμβο με data 7": "To a new node with data 7",
    "null": "null",
    "100": "100",
    "Δέσμευση μνήμης με malloc()": "Memory allocation with malloc()",
    "Ενημέρωση του top": "Top update",
    "Έλεγχος υπερχείλισης (overflow)": "Overflow check",
    "Ανάθεση τιμής στον νέο κόμβο": "Value assignment to the new node",
    "Ο γράφος είναι undirected": "The graph is undirected",
    "Τα βάρη πρέπει να είναι ίσα": "Weights must be equal",
    "Το βάρος εξαρτάται από τη φορά": "The weight depends on the direction (Directed)",
    "Ο γράφος δεν είναι έγκυρος": "The graph is not valid",
    "Ενημέρωση top, ανάκτηση τιμής, αποδέσμευση μνήμης": "Top update, value retrieval, memory deallocation",
    "Ανάκτηση τιμής, αποδέσμευση μνήμης, ενημέρωση top": "Value retrieval, memory deallocation, top update",
    "Έλεγχος κενού, ανάκτηση τιμής, αποδέσμευση μνήμης, ενημέρωση top": "Empty check, value retrieval, memory deallocation, top update",
    "Ανάκτηση τιμής, ενημέρωση top, αποδέσμευση μνήμης": "Value retrieval, top update, memory deallocation",
    "free(temp);": "free(temp);",
    "top--;": "top--;",
    "Εξαρτάται": "Depends",
    "Αναδιοργάνωση στοιχείων σε μονοδιάστατο πίνακα": "Reorganization of elements into a one-dimensional array",
    "Αναδιοργάνωση στοιχείων σε πίνακα με δύο διαστάσεις βάσει συγκεκριμένου κριτηρίου": "Reorganization of elements into a two-dimensional array based on a specific criterion",
    "Αντιγραφή δεδομένων από πίνακα σε πίνακα": "Copying data from one array to another",
    "Διαγραφή περιττών στοιχείων": "Deleting unnecessary elements",
    "Τα στοιχεία διαγράφονται": "Elements are deleted",
    "Δημιουργείται ένας νέος μονοδιάστατος πίνακας και ο 2D διαγράφεται": "A new one-dimensional array is created and the 2D is deleted",
    "Τα ταξινομημένα στοιχεία επανατοποθετούνται στον 2D πίνακα": "Sorted elements are repositioned in the 2D array",
    "Ταξινομούνται ξανά ανά στήλη": "They are sorted again by column",
    "O(m * n)": "O(m * n)",
    "O(n * m²)": "O(n * m²)",
    "O(m² * n²)": "O(m² * n²)",
    "O(m * n²)": "O(m * n²)",
    "Όταν ταξινομούνται ξεχωριστά οι γραμμές": "When rows are sorted separately",
    "Όταν χρησιμοποιούμε επίπεδη μετατροπή και επανατοποθέτηση": "When using flattening conversion and repositioning",
    "Όταν δεν ταξινομούμε καθόλου": "When we do not sort at all",
    "Όταν ταξινομούμε μόνο τις στήλες": "When we sort only the columns",
    "Οι γραμμές έχουν διαφορετικά μεγέθη": "Rows have different sizes",
    "Χρησιμοποιούμε μόνο mergesort": "We use only mergesort",
    "Θέλουμε να ανακατέψουμε τα στοιχεία του πίνακα": "We want to shuffle the array elements",
    "Οι στήλες περιέχουν συγκρίσιμα δεδομένα": "Columns contain comparable data",
    "[[3, 1, 2], [4, 5, 6]]": "[[3, 1, 2], [4, 5, 6]]",
    "[[1, 2, 3], [4, 5, 6]]": "[[1, 2, 3], [4, 5, 6]]",
    "[[1, 3, 2], [5, 6, 4]]": "[[1, 3, 2], [5, 6, 4]]",
    "[[6, 5, 4], [3, 2, 1]]": "[[6, 5, 4], [3, 2, 1]]",
    "[[1, 3], [2, 4]]": "[[1, 3], [2, 4]]",
    "[[4, 3], [2, 1]]": "[[4, 3], [2, 1]]",
    "[[1, 2], [3, 4]]": "[[1, 2], [3, 4]]",
    "[[2, 1], [4, 3]]": "[[2, 1], [4, 3]]",
    "Τα στοιχεία από θέση 2 και μετά θα μετακινηθούν δεξιά": "Elements from position 2 onwards will move to the right",
    "Θα γίνει realloc": "Realloc will happen",
    "Το size θα αυξηθεί": "The size will increase",
    "Το 99 θα μπει στη θέση 2": "99 will be placed in position 2",
    "Γρήγορη προσθήκη στο τέλος": "Fast addition at the end (O(1) amortized)",
    "Αυτόματη διαχείριση μνήμης": "Automatic memory management",
    "Χαμηλή κατανάλωση μνήμης όταν είναι άδειος": "Low memory consumption when empty",
    "Ευελιξία με άγνωστο αριθμό δεδομένων": "Flexibility with an unknown number of data",
    "Αρχικοποίηση με capacity = 0": "Initialization with capacity = 0",
    "Χρήση στατικού πίνακα": "Use of static array",
    "Προκαταβολική αύξηση capacity": "Preemptive capacity increase",
    "Διαγραφή προηγούμενων στοιχείων": "Deletion of previous elements",
    "Επειδή πρέπει να γίνει reallocation κάθε φορά": "Because reallocation must occur every time",
    "Επειδή πρέπει να γίνει ταξινόμηση": "Because sorting must occur",
    "Επειδή απαιτεί έλεγχο για duplicates": "Because it requires checking for duplicates",
    "Επειδή μετακινούνται όλα τα στοιχεία μετά τη θέση εισαγωγής": "Because all elements after the insertion position are moved",
    "Προσθήκη στοιχείου → Δέσμευση μνήμης → Αντιγραφή": "Add element → Allocate memory → Copy",
    "Δέσμευση νέου πίνακα → Αντιγραφή παλιών → Αποδέσμευση παλιού → Προσθήκη νέου": "Allocate new array → Copy old ones → Deallocate old → Add new",
    "Αποδέσμευση παλιού → Προσθήκη στοιχείου → Αντιγραφή": "Deallocate old → Add element → Copy",
    "Προσθήκη → Αύξηση size → Έλεγχος capacity": "Add → Increase size → Check capacity",
    "Διαγραφή από το τέλος": "Deletion from the end",
    "Διαγραφή σε μηδενικό index": "Deletion at zero index",
    "Διαγραφή από άδειο πίνακα": "Deletion from an empty array",
    "Διαγραφή με size > capacity": "Deletion with size > capacity",
    "free() → μετακίνηση → μείωση size": "free() → shift → decrease size",
    "έλεγχος ορίων → μετακίνηση στοιχείων → μείωση size": "bounds check → shift elements → decrease size",
    "μείωση size → αντιγραφή": "decrease size → copy",
    "μετακίνηση → αύξηση size": "shift → increase size",
    "Υποστήριξη garbage collection σε high-level γλώσσες": "Garbage collection support in high-level languages",
    "Όλες οι διαγραφές είναι O(1)": "All deletions are O(1)",
    "Καταναλώνει λιγότερη μνήμη μετά τη διαγραφή": "Consumes less memory after deletion",
    "Αυτόματη μείωση του capacity": "Automatic capacity reduction",
    "[5, 15, 20, 20], size = 4": "[5, 15, 20, 20], size = 4",
    "[5, 15, 20], size = 3": "[5, 15, 20], size = 3",
    "[5, 15, 20], size = 4": "[5, 15, 20], size = 4",
    "[5, 10, 15], size = 3": "[5, 10, 15], size = 3",
    "Ordered delete": "Ordered delete (Shift elements)",
    "Garbage skip": "Garbage skip",
    "Reverse shifting": "Reverse shifting",
    "Unordered delete": "Unordered delete (Swap with last element)",
    "Ο πίνακας σταματά να λειτουργεί": "The array stops working",
    "Εμφανίζονται null τιμές": "Null values appear",
    "Δεν μειώνεται το capacity, άρα γίνεται σπατάλη μνήμης": "The capacity is not reduced, resulting in wasted memory",
    "Η πολυπλοκότητα γίνεται O(log n)": "Complexity becomes O(log n)",
    "[2, 8, 6, 8, 10], size = 5": "[2, 8, 6, 8, 10], size = 5",
    "[2, 10, 6, 8], size = 4": "[2, 10, 6, 8], size = 4",
    "[2, 10, 6, 8, 10], size = 4": "[2, 10, 6, 8, 10], size = 4",
    "[2, 4, 6, 8], size = 4": "[2, 4, 6, 8], size = 4",
    "Προκαλείται memory leak": "A memory leak is caused",
    "Χάνει δεδομένα ο πίνακας": "The array loses data",
    "Προκαλείται segmentation fault": "A segmentation fault is caused",
    "Το στοιχείο αντικαθίσταται αυτόματα με null": "The element is automatically replaced with null",
    "set.remove()": "set.remove()",
    "for-each remove()": "for-each remove()",
    "iterator.remove()": "iterator.remove()",
    "Δεν επιτρέπεται η διαγραφή κατά τη διάρκεια επανάληψης": "Deletion is not allowed during iteration",
    "Πετάει διπλότυπα": "It throws duplicates",
    "Συγχωνεύει σύνολα χωρίς επαναλαμβανόμενα στοιχεία": "Merges sets without repeating elements",
    "Είναι πάντα O(1)": "It is always O(1)",
    "Επιστρέφει ένα ταξινομημένο set": "Returns a sorted set",
    "Ότι αλλάζει την κωδικοποίηση του set": "That it changes the encoding of the set",
    "Ότι προσθέτει νέα στοιχεία": "That it adds new elements",
    "Ότι λειτουργεί μόνο με Strings": "That it only works with Strings",
    "Ότι μεταβάλλει μόνιμα το αρχικό set": "That it permanently modifies the original set",
    "Κλήση της clear()": "Calling clear()",
    "Επανάληψη με iterator()": "Iteration with iterator()",
    "isEmpty() σε μεγάλο set": "isEmpty() on a large set",
    "containsAll() σε μεγάλο δεύτερο set": "containsAll() on a large second set",
    "Δεν αφαιρούνται πραγματικά τα στοιχεία": "The elements are not actually removed",
    "Το αρχικό HashSet μεταβάλλεται και χάνεται η αρχική του μορφή": "The original HashSet is mutated and its original form is lost",
    "Δεν λειτουργεί σε Java": "Does not work in Java",
    "Εισάγονται διπλότυπα από άλλο set": "Duplicates are inserted from another set",
    "true, επειδή το 2 υπάρχει και στα δύο": "true, because 2 exists in both",
    "true, γιατί και τα δύο είναι sets": "true, because both are sets",
    "false, επειδή το 4 δεν υπάρχει στο set1": "false, because 4 does not exist in set1",
    "Θα πετάξει σφάλμα": "It will throw an error",
    "Την τελευταία θέση που ελέγχθηκε": "The last position checked",
    "Τίποτα / None": "Nothing / None",
    "Μηδέν (0)": "Zero (0)",
    "Τον αριθμό των στοιχείων": "The number of elements",
    "Όταν υπάρχουν null τιμές": "When there are null values",
    "Όταν ο πίνακας έχει πολύ μικρό μέγεθος": "When the array has very small size",
    "Όταν ο πίνακας είναι πλήρως ταξινομημένος": "When the array is fully sorted",
    "Όταν οι γραμμές είναι ισομήκεις": "When rows have equal length",
    "11": "11",
    "12": "12",
    "13": "13",
    "10": "10",
    "mid": "mid",
    " mid // n": "mid // n",
    "mid % n": "mid % n",
    "m": "m",
    "Πίνακας 1x1": "1x1 array",
    "Πίνακας με αρνητικούς αριθμούς": "Array with negative numbers",
    "Πίνακας με μη τετράγωνο σχήμα": "Non-square shaped array",
    "Πίνακας χωρίς καθόλου sorting": "Array without any sorting",
    "Όλες οι μέθοδοι δουλεύουν κανονικά": "All methods work normally",
    "Μπορεί να σπάσει το flatten indexing": "Flatten indexing may break",
    "Η binary search είναι πιο αποδοτική": "Binary search is more efficient",
    "Δεν μπορεί να υλοποιηθεί brute-force": "Brute-force cannot be implemented",
    "Αν το mid είναι άρτιος": "If mid is even",
    "Αν το matrix είναι πλήρως ταξινομημένο": "If the matrix is fully sorted",
    "Αν οι γραμμές δεν έχουν ίδιο μήκος": "If the rows do not have the same length",
    "Αν η αναζήτηση είναι επιτυχής": "If the search is successful",
    "top == -1": "top == -1 (Stack Empty)",
    "top == capacity": "top == capacity",
    "top == capacity - 1": "top == capacity - 1 (Stack Full)",
    "top == 0": "top == 0",
    "display()": "display()",
    "pop()": "pop()",
    "isEmpty()": "isEmpty()",
    "2": "2",
    "4 8 9": "4 8 9 (Pop order: 9, 8, 4)",
    "4 9 8": "4 9 8",
    "9 8 4": "9 8 4 (Incorrect Pop Order)",
    "stack is empty": "stack is empty",
    "Παράγει σφάλμα overflow": "Produces overflow error",
    "Προσθέτει στοιχείο": "Adds element",
    "Διαγράφει το πρώτο στοιχείο": "Deletes the first element",
    "False": "False",
    "6": "6",
    "3": "3",
    "int a[3][4];": "int a[3][4];",
    "int c[2][2] = {{5,6}, {7,8}};": "int c[2][2] = {{5,6}, {7,8}};",
    "int d[2][3] = {1, 2, 3, 4, 5, 6};": "int d[2][3] = {1, 2, 3, 4, 5, 6};",
    "int b[][] = {{1, 2}, {3, 4}};": "int b[][] = {{1, 2}, {3, 4}};",

    // --- Hashing / Probing ---
    "Double hashing": "Double hashing",
    "Linear probing": "Linear probing",
    "Quadratic probing": "Quadratic probing",
    "Chaining": "Chaining",
    "0.2": "0.2",
    "0.5": "0.5",
    "0.95": "0.95",
    "0.65": "0.65",
    "Triplehashing": "Triplehashing",
    "Επιστρέφει το μέγεθος της ουράς με βάση τη διαφορά των δεικτών front και rear": "Returns the size of the queue based on the difference between the front and rear pointers",
    "Επιστρέφει πάντα το μέγιστο μέγεθος του πίνακα": "Always returns the maximum size of the array",
    "Επιστρέφει τον αριθμό των στοιχείων μόνο αν η ουρά είναι γεμάτη": "Returns the number of elements only if the queue is full",
    "Επιστρέφει την τιμή του δείκτη rear": "Returns the value of the rear pointer",
    "20": "20",
    "30": "30",
    "50": "50",
    "Να αυξηθεί το μέγεθος του πίνακα": "To increase the size of the array",
    "Να αποτραπούν οι συγκρούσεις": "To prevent collisions",
    "Να αντιμετωπίζονται οι συγκρούσεις αποθηκεύοντας στοιχεία σε λίστες": "To handle collisions by storing elements in lists (Chaining)",
    "Να βελτιωθεί η συνάρτηση hash": "To improve the hash function",
    "Σωστό": "True",
    "Λάθος": "False",
    "Μικρή χρήση μνήμης": "Small memory usage",
    "Δεν υπάρχουν καθόλου συγκρούσεις": "There are absolutely no collisions",
    "Η συνάρτηση κατακερματισμού δεν είναι απαραίτητη": "The hash function is not necessary",
    "Ο πίνακας δεν γεμίζει εύκολα ακόμα και με πολλές συγκρούσεις": "The array does not fill up easily even with many collisions",
    "O(n log n)": "O(n log n)",
    "Ένα μόνο στοιχείο": "A single element",
    "Ένας ακέραιος δείκτης": "An integer pointer",
    "Μια λίστα από στοιχεία με ίδιο hash": "A list of elements with the same hash",
    "Μια συνάρτηση": "A function",
    "Ευκολότερη διαχείριση συγκρούσεων με πολλές εισαγωγές": "Easier collision management with many insertions",
    "Μικρότερη χρήση μνήμης": "Smaller memory usage",
    "Αποδοτικότερη χρήση cache": "More efficient cache usage",
    "Δεν απαιτείται hash function": "Hash function is not required",
    "Δημιουργείται νέο bucket": "A new bucket is created",
    "Ενημερώνεται η τιμή ή αγνοείται η εισαγωγή": "The value is updated or the insertion is ignored",
    "Διαγράφεται το προηγούμενο κλειδί": "The previous key is deleted",
    "Γίνεται επανακατανομή όλων των στοιχείων": "All elements are reallocated",
    "Το πλήθος των κλειδιών μόνο": "The number of keys only",
    "Το μέγεθος του πίνακα μόνο": "The size of the array only",
    "Η ποιότητα της hash function": "The quality of the hash function",
    "Το είδος της λίστας": "The type of list",
    "Υπολογισμός index με hash function": "Calculation of index using hash function",
    "Διαγραφή του bucket": "Deletion of the bucket",
    "Εύρεση του στοιχείου στη λίστα": "Finding the element in the list",
    "Αφαίρεση του στοιχείου": "Removal of the element",
    "O(1 + 4)": "O(1 + α) (where α is load factor/list length)",
    "Αναζήτηση σε όλα τα buckets": "Search in all buckets",
    "Άμεση διαγραφή χωρίς αναζήτηση": "Direct deletion without search",
    "Αναζήτηση στο bucket 3 και αφαίρεση": "Search in bucket 3 and removal",
    "Επανακατανομή του 23": "Reallocation of 23",
    "[10]": "[10]",
    "[21]": "[21]",
    "[32]": "[32]",
    "[21, 32]": "[21, 32]",
    "Το hash table διαγράφεται": "The hash table is deleted",
    "Εμφανίζεται σφάλμα": "An error appears",
    "Δεν γίνεται καμία ενέργεια": "No action is taken",
    "Διαγράφεται το πρώτο στοιχείο του bucket": "The first element of the bucket is deleted",
    "Ισορροπημένη κατανομή των keys": "Balanced distribution of keys",
    "Κακή hash συνάρτηση": "Poor hash function",
    "Μικρό μέγεθος buckets": "Small bucket size",
    "Μικρό load factor": "Small load factor",
    "Χρήση binary search στις λίστες": "Use binary search in the lists",
    "Χρήση μεγάλων buckets": "Use large buckets",
    "Καλή κατανομή από τη hash συνάρτηση": "Good distribution from the hash function",
    "Αύξηση του load factor": "Increase the load factor",
    "ResetAll()": "ResetAll()",
    "DeleteAll()": "DeleteAll()",
    "Clear()": "Clear()",
    "Purge()": "Purge()",
    "Επιστρέφεται null ή 'δεν βρέθηκε'": "null or 'not found' is returned",
    "Προκαλείται σφάλμα": "An error is caused",
    "Το στοιχείο προστίθεται αυτόματα": "The element is automatically added",
    "Η hash table μηδενίζεται": "The hash table is reset to zero",
    "Την τιμή -1": "The value -1",
    "Null ή None (ανάλογα τη γλώσσα)": "Null or None (depending on the language)",
    "Το index του πίνακα": "The array index",
    "Τον πίνακα ολόκληρο": "The entire array",
    "Το πλήθος των συγκρούσεων (collisions)": "The number of collisions",
    "Το πλήθος των buckets": "The number of buckets",
    "Το sorting των κλειδιών": "The sorting of the keys",
    "get(key)": "get(key)",
    "find()": "find()",
    "access()": "access()",
    "valueOf(key)": "valueOf(key)",
    "Διαγράφει κλειδιά": "Deletes keys",
    "Αναζητά συγκεκριμένες τιμές": "Searches for specific values",
    "Επιστρέφει όλα τα κλειδιά του πίνακα": "Returns all keys in the table",
    "Ανασυντάσσει τα buckets": "Reallocates the buckets",
    "Τη λίστα των κενών θέσεων του πίνακα": "The list of empty slots in the table",
    "True αν δεν υπάρχουν καταχωρημένα στοιχεία": "True if there are no registered elements (isEmpty)",
    "Αν ο πίνακας περιέχει null τιμές": "If the array contains null values",
    "Πλήθος κενών buckets": "Number of empty buckets",
    "Length()": "Length()",
    "Count()": "Count()",
    "Size()": "Size()",
    "Total()": "Total()",
    "Χρησιμοποιεί τετραγωνικά βήματα": "Uses quadratic steps (Quadratic Probing)",
    "Ψάχνει με δεύτερη hash συνάρτηση": "Searches with a second hash function (Double Hashing)",
    "Ελέγχει διαδοχικά τις επόμενες θέσεις": "Checks successive next positions (Linear Probing)",
    "Κάνει επανεκκίνηση του πίνακα": "Resets the table",
    "7, 8, 9": "7, 8, 9",
    "7, 9, 11": "7, 9, 11",
    "7, 6, 5": "7, 6, 5",
    "7, 0, 1": "7, 0, 1",
    "Αν ξεχάσουμε να καλέσουμε τη συνάρτηση hash": "If we forget to call the hash function",
    "Αν το στοιχείο διαγράφηκε χωρίς να μαρκαριστεί ως DELETED": "If the element was deleted without being marked as DELETED",
    "Αν άλλαξε η στρατηγική probing": "If the probing strategy changed",
    "Αν το στοιχείο έχει τιμή null": "If the element has a null value",
    "A. 4, 5, 6, 7, ...": "A. 4, 5, 6, 7, ... (Linear Probing: step i)",
    "4, 5, 8, 2, ...": "4, 5, 8, 2, ...",
    "4, 5, 7, 10, ...": "4, 5, 7, 10, ...",
    "4, 5, 7, 0, 4": "4, 5, 7, 0, 4",
    "Το στοιχείο υπάρχει": "The element exists",
    "Το στοιχείο έχει διαγραφεί": "The element has been deleted (DELETED slot)",
    "Το στοιχείο δεν υπάρχει": "The element does not exist (NULL slot)",
    "Πρέπει να γίνει rehash": "Rehash must occur",
    "Επειδή ίσως υπάρχει το στοιχείο σε επόμενη θέση λόγω προηγούμενου probing": "Because the element might exist in a subsequent position due to previous probing",
    "Γιατί DELETED σημαίνει επιτυχία": "Because DELETED means success",
    "Γιατί DELETED είναι το ίδιο με null": "Because DELETED is the same as null",
    "Για να μην ξαναχρησιμοποιηθεί η θέση": "To prevent the position from being reused",
    "Η αναζήτηση μπορεί να σταματήσει πρόωρα, χάνοντας το στοιχείο": "The search may stop prematurely, losing the element",
    "Δεν θα μπορούν να εισαχθούν νέα στοιχεία": "New elements will not be able to be inserted",
    "Όταν γίνει rehash": "When rehash occurs",
    "Όταν η στρατηγική probing αλλάξει": "When the probing strategy changes",
    "Όταν εντοπιστεί null ή επιστρέψουμε στην αρχική θέση": "When null is found or we return to the initial position",
    "Όταν η θέση είναι DELETED": "When the position is DELETED",
    "Για να εντοπιστεί σωστά το στοιχείο": "To correctly locate the element",
    "Για να μειώνεται το load factor": "To reduce the load factor",
    "Για να μην καταστρέφονται τα στοιχεία": "To prevent data destruction",
    "Για να γίνει hashing πιο αποδοτικά": "To make hashing more efficient",
    "Διαγράφει το υπάρχον στοιχείο": "Deletes the existing element",
    "Δημιουργεί συνδεδεμένη λίστα": "Creates a linked list",
    "Εφαρμόζει probing για εύρεση νέας θέσης": "Applies probing to find a new position",
    "Σταματά την εισαγωγή": "Stops the insertion",
    "Ο πίνακας να είναι γεμάτος": "The table must be full",
    "Συνδεδεμένες λίστες σε κάθε θέση": "Linked lists in every position",
    "Hash συνάρτηση και στρατηγική probing": "A Hash function and a probing strategy",
    "Το μέγεθος του πίνακα να είναι περιττός αριθμός": "The size of the table must be an odd number",
    "Θεωρείται μόνιμα άχρηστη": "It is considered permanently useless",
    "Μπορεί να χρησιμοποιηθεί ξανά για νέα εισαγωγή": "Can be reused for new insertion",
    "Παραλείπεται εντελώς": "Is skipped entirely",
    "Πρέπει να διαγραφεί πρώτα": "Must be deleted first",
    "Στη θέση 6": "At position 6",
    "Στη θέση 0": "At position 0",
    "Στη θέση 2": "At position 2",
    "Δεν θα εισαχθεί": "It will not be inserted",
    "Συμπίεση του πίνακα": "Table compression",
    "Επαναφορά μόνο των DELETED θέσεων": "Restoration of only DELETED slots",
    "Rehashing με αναδημιουργία του πίνακα": "Rehashing with table recreation",
    "Αγνοση των DELETED κατά την αναζήτηση": "Ignoring DELETED during search",
    "10": "10",
    "21": "21",
    "32": "32",
    "5": "5",

    // --- AVL Trees / BST ---
    "Πίνακες": "Arrays",
    "Ισορροπημένα δυαδικά δέντρα αναζήτησης": "Balanced Binary Search Trees",
    "Μη κατευθυνόμενοι γράφοι": "Undirected graphs",
    "Συνδεδεμένες λίστες": "Linked lists",
    "Είναι δυαδικά δέντρα αναζήτησης": "They are Binary Search Trees",
    "Είναι πάντα ισορροπημένα": "They are always balanced",
    "Επιτρέπεται BF(x) = 3 για κάποιους κόμβους": "BF(x) = 3 is allowed for some nodes",
    "Το BF(x) κυμαίνεται μεταξύ -1 και 1": "The BF(x) ranges between -1 and 1",
    "Ο κόμβος είναι balanced": "The node is balanced",
    "Ο κόμβος είναι right-heavy": "The node is right-heavy",
    "Ο κόμβος είναι left-heavy και το δέντρο είναι μη ισορροπημένο": "The node is left-heavy and the tree is unbalanced",
    "Ο συντελεστής ισορροπίας είναι αποδεκτός": "The balance factor is acceptable",
    "Αναζήτηση": "Search",
    "Εισαγωγή": "Insertion",
    "Εκτύπωση": "Printing",
    "Απαρίθμηση κόμβων": "Node enumeration",
    "Σταθερή απόδοση O(log n)": "Constant performance O(log n)",
    "Υψηλή κατανάλωση μνήμης": "High memory consumption",
    "Κατάλληλα για δυναμικά δεδομένα": "Suitable for dynamic data",
    "Προβλέψιμη αναζήτηση": "Predictable search",
    "Συμπίεση εικόνας": "Image compression",
    "Ευρετηρίαση βάσεων δεδομένων": "Database indexing",
    "Διαχείριση μνήμης": "Memory management",
    "Μεταγλωττιστές": "Compilers",
    "Χαμηλή κατανάλωση μνήμης": "Low memory consumption",
    "Σταθερή απόδοση": "Constant performance",
    "Περιστροφές μετά από διαγραφή": "Rotations after deletion",
    "Ένα AVL Tree μπορεί να περιέχει κόμβο με BF = 2": "An AVL Tree can contain a node with BF = 2",
    "Οι περιστροφές γίνονται για να αποκατασταθεί η ισορροπία": "Rotations are performed to restore balance",
    "Η συνάρτηση εισαγωγής δεν μπορεί να προκαλέσει περιστροφή": "The insertion function cannot cause rotation",
    "Τα AVL δέντρα δεν είναι κατάλληλα για χρήση σε βάσεις δεδομένων": "AVL trees are not suitable for use in databases",
    "Όταν εντοπιστεί η τιμή ή φτάσουμε σε NULL": "When the value is found or we reach NULL",
    "Όταν φτάσουμε στο ύψος του δέντρου": "When we reach the height of the tree",
    "Όταν περάσουμε 10 κόμβους": "When we pass 10 nodes",
    "Όταν η τιμή είναι μεγαλύτερη από τη ρίζα": "When the value is greater than the root",
    "Μικρότερη κατανάλωση μνήμης": "Lower memory consumption",
    "Σταθερή απόδοση ανεξάρτητα από τη σειρά εισαγωγής": "Constant performance regardless of insertion order",
    "Δεν χρειάζεται σύγκριση τιμών": "Does not require value comparison",
    "Υλοποιείται χωρίς κώδικα": "Is implemented without code",
    "Η τιμή βρέθηκε": "The value was found",
    "Το στοιχείο υπάρχει στο δεξί υποδέντρο": "The element exists in the right subtree",
    "Το δέντρο είναι κενό": "The tree is empty",
    "Έγινε λάθος στον αλγόριθμο": "There was an error in the algorithm",
    "Γιατί χρησιμοποιεί hash": "Because it uses hash",
    "Γιατί διατηρείται ισορροπημένο": "Because it remains balanced",
    "Γιατί δεν υπάρχουν υποδέντρα": "Because there are no subtrees",
    "Γιατί αποθηκεύει όλες τις τιμές σε πίνακα": "Because it stores all values in an array",
    "Η σειρά εισαγωγής των στοιχείων": "The insertion order of the elements",
    "Η τρέχουσα ισορροπία του δέντρου": "The current balance of the tree",
    "Η χρήση επανάληψης ή αναδρομής": "The use of iteration or recursion",
    "Η τιμή του στοιχείου που ψάχνουμε": "The value of the element we are searching for",
    "Είναι πάντα O(1)": "It is always O(1)",
    "Χρειάζεται in-order διάσχιση": "It requires in-order traversal",
    "Πηγαίνει πάντα στο δεξί υποδέντρο": "It always goes to the right subtree",
    "Επηρεάζεται από το ύψος του δέντρου": "It is affected by the height of the tree",
    "Διαγράφει το υπάρχον στοιχείο": "Deletes the existing element",
    "Δημιουργεί συνδεδεμένη λίστα": "Creates a linked list",
    "Εφαρμόζει probing για εύρεση νέας θέσης": "Applies probing to find a new position",
    "Σταματά την εισαγωγή": "Stops the insertion",
    "Ο πίνακας να είναι γεμάτος": "The table must be full",
    "Συνδεδεμένες λίστες σε κάθε θέση": "Linked lists in every position",
    "Hash συνάρτηση και στρατηγική probing": "A Hash function and a probing strategy",
    "Το μέγεθος του πίνακα να είναι περιττός αριθμός": "The size of the table must be an odd number",
    "Θεωρείται μόνιμα άχρηστη": "It is considered permanently useless",
    "Μπορεί να χρησιμοποιηθεί ξανά για νέα εισαγωγή": "Can be reused for new insertion",
    "Παραλείπεται εντελώς": "Is skipped entirely",
    "Πρέπει να διαγραφεί πρώτα": "Must be deleted first",
    "Στη θέση 6": "At position 6",
    "Στη θέση 0": "At position 0",
    "Στη θέση 2": "At position 2",
    "Δεν θα εισαχθεί": "It will not be inserted",
    "Συμπίεση του πίνακα": "Table compression",
    "Επαναφορά μόνο των DELETED θέσεων": "Restoration of only DELETED slots",
    "Rehashing με αναδημιουργία του πίνακα": "Rehashing with table recreation",
    "Αγνοση των DELETED κατά την αναζήτηση": "Ignoring DELETED during search",
    "Κάθε κόμβος έχει απεριόριστο αριθμό παιδιών": "Each node has an unlimited number of children",
    "Κάθε κόμβος έχει το πολύ δύο παιδιά": "Each node has at most two children",
    "Κάθε κόμβος έχει ακριβώς δύο παιδιά": "Each node has exactly two children",
    "Οι κόμβοι δεν έχουν παιδιά": "Nodes have no children",
    "Τυχαίος εσωτερικός κόμβος": "Random internal node",
    "Πρώτο φύλλο": "First leaf",
    "Κόμβος με τιμή 0": "Node with value 0",
    "Ρίζα": "Root",
    "Αριστερό → Δεξί → Ρίζα": "Left → Right → Root (Postorder)",
    "Αριστερό → Ρίζα → Δεξί": "Left → Root → Right (Inorder)",
    "Δεξί → Αριστερό → Ρίζα": "Right → Left → Root",
    "Ρίζα → Αριστερό → Δεξί": "Root → Left → Right (Preorder)",
    "Τέλειο": "Perfect (All levels full)",
    "Συμπληρωμένο": "Complete (All levels full except last, which is filled left to right)",
    "Ισορροπημένο": "Balanced",
    "Εκφυλισμένο": "Degenerate",
    "Ταξινόμηση δεδομένων": "Data sorting",
    "Υλοποίηση heaps και priority queues": "Implementation of heaps and priority queues",
    "Όλα τα παραπάνω": "All of the above",
    "A B C": "A B C (Inorder)",
    "B A C": "B A C",
    "C B A": "C B A (Reverse Inorder)",
    "A C B": "A C B",
    "Το ύψος του δέντρου να είναι μονός αριθμός": "The height of the tree must be an odd number",
    "Η ρίζα να έχει δύο παιδιά": "The root must have two children",
    "Όλοι οι εσωτερικοί κόμβοι να έχουν δύο παιδιά και όλα τα φύλλα να είναι στο ίδιο επίπεδο": "All internal nodes must have two children and all leaves must be at the same level (Perfect Tree)",
    "Όλοι οι κόμβοι να έχουν ένα παιδί": "All nodes must have one child",
    "Ελάχιστο: 1, Μέγιστο: n/2": "Minimum: 1, Maximum: n/2",
    "Ελάχιστο: 1, Μέγιστο: n−1": "Minimum: 1, Maximum: n−1",
    "Ελάχιστο: 1, Μέγιστο: n": "Minimum: 1, Maximum: n",
    "Ελάχιστο: 1, Μέγιστο: ⌊(n+1)/2⌋": "Minimum: 1, Maximum: ⌊(n+1)/2⌋ (Leaves in a Complete Binary Tree)",
    "Στην πλήρη, το rear + 1 είναι ίσο με το front": "In the full queue, rear + 1 is equal to front",
    "Στην άδεια, το rear είναι ίσο με το front": "In the empty queue, rear is equal to front",
    "Ο κόμβος είναι right-heavy": "The node is right-heavy",
    "Ο κόμβος είναι left-heavy και το δέντρο είναι μη ισορροπημένο": "The node is left-heavy and the tree is unbalanced",
    "Ο συντελεστής ισορροπίας είναι αποδεκτός": "The balance factor is acceptable",
    "Μεταβολή ύψους σε υποδέντρο": "Height change in a subtree",
    "Διαγραφή φύλλου": "Deletion of a leaf",
    "Αλλαγή balance factor σε πρόγονο": "Change of balance factor in an ancestor",
    "Εισαγωγή νέου κόμβου": "Insertion of a new node",
    "Ένας κόμβος έχει δεξί παιδί με αριστερό παιδί": "A node has a right child with a left child (RL case)",
    "Ένας κόμβος έχει αριστερό παιδί με δεξί παιδί": "A node has a left child with a right child (LR case)",
    "Ένας κόμβος έχει μόνο αριστερό παιδί": "A node has only a left child",
    "Ένας κόμβος έχει δεξιό παιδί με δεξί παιδί": "A node has a right child with a right child (RR case)",
    "Αναζήτηση successor του 30": "Search for successor of 30",
    "Left-Right περιστροφή": "Left-Right rotation",
    "Επανυπολογισμός ύψους και έλεγχος balance στον 50": "Recalculation of height and balance check on 50",
    "Εισαγωγή νέου κόμβου για ισορροπία": "Insertion of a new node for balance",
    "LL": "LL (Left-Left, Right Rotation)",
    "RR": "RR (Right-Right, Left Rotation)",
    "LR": "LR (Left-Right, Double Rotation)",
    "RL": "RL (Right-Left, Double Rotation)",
    "Αναδιάταξη όλων των κόμβων": "Rearrangement of all nodes",
    "Ενημέρωση balance factor και έλεγχος ισορροπίας": "Update balance factor and check balance",
    "Διαγραφή του μέγιστου κόμβου": "Deletion of the maximum node",
    "Αλλαγή της ρίζας": "Change of the root",
    "Χρειάζεται πάντοτε περιστροφή": "Rotation is always needed",
    "Απαιτείται διαγραφή": "Deletion is required",
    "Δεν απαιτείται καμία ενέργεια ισορροπίας": "No balancing action is required",
    "Ολόκληρο το δέντρο ισοπεδώνεται": "The entire tree is flattened",
    "Παραμένει πάντα ίδιο": "Always remains the same",
    "Αυξάνεται μόνο αν προστίθεται στο πιο βαθύ υποδέντρο": "Increases only if it is added to the deepest subtree",
    "Μειώνεται σε κάθε περίπτωση": "Decreases in any case",
    "Αυξάνεται μόνο αν ο νέος κόμβος είναι φύλλο": "Increases only if the new node is a leaf",
    "Από φύλλο προς ρίζα": "From leaf to root",
    "Από ρίζα προς φύλλο": "From root to leaf",
    "Τυχαία": "Randomly",
    "Μόνο στους κόμβους χωρίς παιδιά": "Only on nodes without children",
    "Όταν βρεθεί κόμβος με balance factor 2": "When a node with balance factor 2 is found",
    "Μόλις βρεθεί κόμβος με balance factor 0 ή σταθερό": "As soon as a node with balance factor 0 or stable is found",
    "Όταν γίνει διαγραφή": "When deletion occurs",
    "Όταν όλοι οι κόμβοι έχουν παιδιά": "When all nodes have children",
    "Ο κόμβος που εισήχθη": "The node that was inserted",
    "Ο γονέας του κόμβου που εισήχθη": "The parent of the node that was inserted",
    "Ο πρώτος κόμβος από κάτω προς τα πάνω με |balance factor| > 1": "The first node from bottom to top with |balance factor| > 1",
    "Η ρίζα του δέντρου": "The root of the tree",
    "Αυξάνεται κατά 1": "Increases by 1",
    "Μειώνεται κατά 1": "Decreases by 1",
    "Αυξάνεται κατά 2": "Increases by 2",
    "Μειώνεται κατά 2": "Decreases by 2",
    "log₂(n)": "log₂(n)",
    "√n": "√n",
    "n": "n",
    "n²": "n²",
    "Είναι πάντα BST": "It is always a BST",
    "Είναι ένα συμπληρωμένο δυαδικό δέντρο": "It is a complete binary tree",
    "Δεν έχει ρίζα": "It does not have a root",
    "Υποστηρίζει μόνο εισαγωγή": "It only supports insertion",
    "2i": "2i",
    "i+2": "i+2",
    "2i+2": "2i+2",
    "(i+2)/2": "(i+2)/2",
    "O(n)": "O(n)",
    "O(n logn)": "O(n logn)",
    "Εύρεση median σε ταξινομημένο πίνακα": "Finding median in a sorted array",
    "Ουρές προτεραιότητας": "Priority queues",
    "Εύρεση συντομότερης διαδρομής": "Finding the shortest path",
    "Heap Sort": "Heap Sort",
    "2i+1": "2i+1",
    "i-1": "i-1",
    "(i+1)*2": "(i+1)*2",
    "Διαγραφή κορυφής": "Deletion of top (root)",
    "Ανακατασκευή Heap": "Heap reconstruction",
    "Εύρεση κορυφής": "Finding the top (root)",
    "Στη ρίζα": "At the root",
    "Στο δεξιότερο φύλλο": "At the rightmost leaf",
    "Στην πρώτη διαθέσιμη θέση (τέλος)": "At the first available position (end)",
    "Στο μικρότερο παιδί": "At the smallest child",
    "Το νέο στοιχείο είναι μικρότερο από τον γονέα": "The new element is smaller than the parent",
    "Το νέο στοιχείο είναι μεγαλύτερο από τον γονέα": "The new element is greater than the parent",
    "Το νέο στοιχείο είναι ίσο με τη ρίζα": "The new element is equal to the root",
    "Το μικρότερο από τα δύο": "The smaller of the two",
    "Πάντα το αριστερό": "Always the left one",
    "Το μεγαλύτερο": "The larger one",
    "Το μικρότερο από όλα τα εγγόνια": "The smallest of all grandchildren",
    "Ο πίνακας πρέπει να είναι ταξινομημένος.": "The array must be sorted.",
    "Η ρίζα βρίσκεται πάντα στη μέση του πίνακα.": "The root is always in the middle of the array.",
    "Ο γονέας του στοιχείου στη θέση i είναι στη θέση (i + 1) // 2.": "The parent of the element at position i is at position (i + 1) // 2.",
    "Ο γονέας του στοιχείου στη θέση i βρίσκεται στη θέση (i - 1) // 2.": "The parent of the element at position i is at position (i - 1) // 2.",
    "Δεν υπάρχει καμία εγγύηση σχετικά με τη διάταξη αριστερών και δεξιών παιδιών.": "There is no guarantee regarding the arrangement of left and right children.",
    "Ο πίνακας είναι αραιός.": "The array is sparse.",
    "Τα δεδομένα αποθηκεύονται μόνο στη ρίζα.": "Data is stored only at the root.",
    "Οι δείκτες δεν επιτρέπουν προσπέλαση.": "Pointers do not allow access.",
    "Ταξινόμηση ολόκληρου του Heap": "Sorting the entire Heap",
    "Επαναλαμβανόμενα deletes": "Repeated deletes",
    "Χρήση βοηθητικής ουράς προτεραιότητας": "Use of auxiliary priority queue",
    "Γραμμική αναζήτηση στον πίνακα": "Linear search in the array",
    "Ενημέρωση στοιχείου σε φύλλο": "Updating an element in a leaf",
    "Έλεγχος πλήρωσης επιπέδο": "Level fullness check",
    "Ναι, γιατί ο πίνακας είναι σχεδόν ταξινομημένος": "Yes, because the array is almost sorted",
    "Ναι, γιατί κάθε γονέας είναι μεγαλύτερος από τα παιδιά του": "Yes, because every parent is greater than its children",
    "Όχι, γιατί το 25 δεν είναι στο σωστό επίπεδο": "No, because 25 is not at the correct level",
    "Όχι, γιατί το 35 είναι δεξιά του 20": "No, because 35 is to the right of 20",
    "Θα γινόταν Min-Heap": "It would become a Min-Heap",
    "Θα γινόταν πιο αργός ο αλγόριθμος": "The algorithm would become slower",
    "Θα έσπαγε το δέντρο": "The tree would break",
    "Το αποτέλεσμα θα ήταν έγκυρο Max-Heap": "The result would be a valid Max-Heap",
    "Αναδρομική Αναζήτηση με pruning": "Recursive Search with pruning",
    "Binary Inorder Traversal": "Binary Inorder Traversal",
    "Δεν υπάρχει καθολική διάταξη μεταξύ κόμβων": "There is no global arrangement between nodes",
    "Έλλειψη δείκτη πατέρα": "Lack of parent pointer",
    "Δεν είναι πλήρες δέντρο": "It is not a complete tree",
    "Έχει μεγάλο χώρο αποθήκευσης": "It has large storage space",
    "Επειδή το υποδένδρο μπορεί να περιέχει μεγαλύτερους κόμβους": "Because the subtree can contain larger nodes",
    "Επειδή τα παιδιά θα είναι μεγαλύτερα": "Because the children will be larger",
    "Δεν μπορούμε να σταματήσουμε": "We cannot stop",
    "Επειδή η ιδιότητα του Max-Heap εγγυάται ότι τα παιδιά θα είναι μικρότερα": "Because the Max-Heap property guarantees that children will be smaller",
    "Δεν μπορεί να εφαρμοστεί": "Cannot be applied",
    "Ενδέχεται να παραλείψει κόμβους": "It may omit nodes",
    "Πάντα εξετάζει όλα τα στοιχεία": "Always examines all elements",
    "Είναι πιο αργή από την επαναληπτική": "It is slower than the iterative one",
    "Όταν βρούμε κόμβο μικρότερο από το target": "When we find a node smaller than the target",
    "Όταν συναντήσουμε κόμβο μεγαλύτερο από το target": "When we encounter a node larger than the target",
    "Όταν βρούμε το στοιχείο": "When we find the element",
    "Όταν φτάσουμε φύλλο": "When we reach a leaf",
    "Όταν το στοιχείο είναι κοντά στη ρίζα": "When the element is close to the root",
    "Όταν οι κόμβοι είναι όλοι μικρότεροι από το target": "When the nodes are all smaller than the target",
    "Όταν το στοιχείο δεν υπάρχει": "When the element does not exist",
    "Όταν το Heap είναι πλήρες": "When the Heap is full",
    "Το Min-Heap θα αλλάξει διάταξη": "The Min-Heap will change arrangement",
    "Θα αφαιρεθούν στοιχεία": "Elements will be removed",
    "Δεν θα αλλάξει τίποτα": "Nothing will change",
    "Θα μετατραπεί σε Max-Heap": "It will be converted to a Max-Heap",
    "sift_up": "sift_up",
    "sift_down": "sift_down",
    "heapify": "heapify",
    "push": "push",
    "pop": "pop",
    "sift_down ή sift_up": "sift_down or sift_up",
    "merge": "merge",
    "Στο τέλος του πίνακα": "At the end of the array",
    "Δεν υπάρχει καθολική διάταξη μεταξύ κόμβων": "There is no global arrangement between nodes",
    "Η ρίζα είναι πάντα μεγαλύτερη από όλους": "The root is always greater than all others",
    "Η σειρά δεν έχει σημασία": "Order does not matter",
    "Η δομή γίνεται max-heap": "The structure becomes max-heap",
    "Δημιουργεί ισοζυγισμένο δυαδικό δέντρο": "Creates a balanced binary tree",
    "Διατηρεί την ιδιότητα Heap σε δύο ενώσεις": "Maintains the Heap property in two unions",
    "Εκτελεί sorting": "Performs sorting",

    // --- Hash Sets / Maps / Treesets ---
    "Μοναδικά στοιχεία χωρίς συγκεκριμένη σειρά": "Unique elements without specific order",
    "Στοιχεία με διπλότυπα": "Elements with duplicates",
    "Ταξινομημένα στοιχεία": "Sorted elements",
    "Μοναδικά στοιχεία με συγκεκριμένη σειρά": "Unique elements with specific order",
    "Διαγραφή": "Deletion",
    "Ταξινόμηση": "Sorting",
    "Python": "Python",
    "C++": "C++",
    "Java": "Java",
    "C#": "C#",
    "Αποθήκευση επαναλαμβανόμενων στοιχείων": "Storing repeating elements",
    "Αναπαράσταση γραφήματος με ακμές": "Graph representation with edges",
    "Ταξινομημένη λίστα δεδομένων": "Sorted list of data",
    "Ανίχνευση διπλότυπων σε λίστα": "Duplicate detection in a list",
    "Υποστηρίζουν ταξινόμηση": "They support sorting",
    "Χρησιμοποιούν λίγη μνήμη": "They use little memory",
    "Η σειρά εισαγωγής διατηρείται": "Insertion order is maintained",
    "Δεν υποστηρίζουν προβλέψιμη σειρά στοιχείων": "They do not support predictable element order",
    "Για να ταξινομεί τα στοιχεία": "To sort the elements",
    "Για να αποθηκεύει διπλότυπα": "To store duplicates",
    "Για να υπολογίζει μοναδικό κλειδί κάθε στοιχείου": "To calculate a unique key for each element",
    "Για να συγκρίνει τα στοιχεία αριθμητικά": "To compare the elements numerically",
    "Διατηρεί ταξινόμηση": "Maintains sorting",
    "Είναι πιο γρήγορο σε εισαγωγή/αναζήτηση": "It is faster in insertion/search",
    "Υποστηρίζει διπλότυπα": "Supports duplicates",
    "Χρησιμοποιεί λιγότερη μνήμη": "Uses less memory",
    "Το HashSet υποστηρίζει τις πράξεις ένωση και τομή": "HashSet supports union and intersection operations",
    "Τα HashSet και HashMap χρησιμοποιούν παρόμοια τεχνική υλοποίησης": "HashSet and HashMap use a similar implementation technique",
    "Το HashSet επιτρέπει στοιχεία τύπου null σε όλες τις γλώσσες": "HashSet allows null elements in all languages",
    "Το HashSet δεν εγγυάται σταθερή σειρά εμφάνισης των στοιχείων": "HashSet does not guarantee a stable display order of elements",
    "Να μετατραπεί σε λίστα": "Convert to a list",
    "Να χρησιμοποιηθεί TreeSet": "Use TreeSet",
    "Να αποθηκεύονται όλα τα στοιχεία ως strings": "Store all elements as strings",
    "Να αυξηθεί το μέγεθος του πίνακα κατακερματισμού": "Increase the size of the hash table array",
    "Λίστα γειτνίασης": "Adjacency list",
    "Πίνακας γειτνίασης": "Adjacency matrix",
    "Δυαδικό δέντρο": "Binary tree",
    "Στοίβα": "Stack",
    "Ο πίνακας γίνεται 5x4": "The array becomes 5x4",
    "Ο πίνακας γίνεται 4x5": "The array becomes 4x5",
    "Ο πίνακας γίνεται 5x5": "The array becomes 5x5",
    "Ο πίνακας δεν αλλάζει": "The array does not change",
    "Αλλάζει το μέγεθος του πίνακα": "The size of the array changes",
    "Ανατίθεται τιμή null στον κόμβο": "Null value is assigned to the node",
    "Ο κόμβος απλώς αγνοείται": "The node is simply ignored",
    "Αφαιρείται από τη δομή και από όλες τις λίστες γειτόνων": "Removed from the structure and all neighbor lists",
    "Γίνεται n x (n-1)": "Becomes n x (n-1)",
    "Γίνεται (n+1) x (n+1)": "Becomes (n+1) x (n+1)",
    "Δεν αλλάζει": "Does not change",
    "Μηδενίζονται όλες οι τιμές": "All values are set to zero",
    "Να διατηρηθεί η ακμή Α→Β": "Maintain the edge A→B",
    "Να προστεθεί νέος κόμβος στη θέση του": "Add a new node in its place",
    "Να αφαιρεθούν όλες οι αναφορές προς και από τον Β": "Remove all references to and from B",
    "Τίποτα, ο γράφος το χειρίζεται μόνος του": "Nothing, the graph handles it itself",
    "Είναι αποδοτικοί σε μνήμη για αραιούς γράφους": "They are memory efficient for sparse graphs",
    "Είναι σταθερού μεγέθους": "They are of fixed size",
    "Μπορούν να δείξουν ύπαρξη ή απουσία ακμής": "They can show the presence or absence of an edge",
    "Υποστηρίζουν εύκολα κατευθυνόμενες ακμές": "They easily support directed edges",
    "Έλεγχος ύπαρξης ακμής": "Checking for edge existence",
    "Εισαγωγή κόμβου": "Node insertion",
    "Εύρεση όλων των γειτόνων ενός κόμβου": "Finding all neighbors of a node",
    "Μέτρηση πλήθους ακμών": "Counting the number of edges",
    "Μια στοίβα ή ουρά": "A stack or queue",
    "Ένα σύνολο επισκεφθέντων (visited)": "A set of visited nodes",
    "Ένας πίνακας προσβάσεων": "An access array",
    "Καμία από τις παραπάνω": "None of the above",
    "Συνεχίζει προς οποιονδήποτε κόμβο": "Continues to any node",
    "Σταματά εντελώς": "Stops completely",
    "Επιστρέφει πίσω στη στοίβα για να εξετάσει άλλους κόμβους": "Returns back to the stack to examine other nodes (DFS Backtracking)",
    "Ξεκινά νέα αναζήτηση από τυχαίο κόμβο": "Starts a new search from a random node",
    "A → B, B → C, C → D": "A → B, B → C, C → D",
    "A → B, B → C, C → A": "A → B, B → C, C → A (Cycle)",
    "A → B, B → C, C → D, D → E": "A → B, B → C, C → D, D → E",
    "A → B, B → C, C → D, D → F": "A → B, B → C, C → D, D → F",
    "Θέλουμε να βρούμε τη μικρότερη απόσταση μεταξύ κόμβων": "We want to find the shortest distance between nodes (BFS)",
    "Θέλουμε να εξετάσουμε αν υπάρχει κύκλος": "We want to check if a cycle exists (DFS/BFS)",
    "Θέλουμε να ελέγξουμε εξαρτήσεις μεταξύ κόμβων": "We want to check dependencies between nodes",
    "Θέλουμε να επισκεφθούμε πρώτα τους πιο απομακρυσμένους κόμβους": "We want to visit the most distant nodes first",
    "Δεν βρίσκει ποτέ κύκλους": "It never finds cycles",
    "Καταναλώνει πολύ χώρο λόγω της ουράς": "Consumes a lot of space due to the queue (BFS)",
    "Υπάρχει κίνδυνος υπερχείλισης στοίβας (stack overflow)": "There is a risk of stack overflow (DFS)",
    "Δεν επισκέπτεται όλους τους κόμβους": "It does not visit all nodes",
    "Η ύπαρξη ακμής (A → B) εγγυάται την ύπαρξη και της ακμής (B → A)": "The existence of edge (A → B) guarantees the existence of edge (B → A) (Undirected Graph)",
    "Η DFS δεν λειτουργεί αν υπάρχει κύκλος": "DFS does not work if a cycle exists",
    "Η BFS δεν χρειάζεται το σύνολο visited αν δεν υπάρχει κύκλος": "BFS does not need the visited set if there is no cycle",
    "Αν δεν υπάρχουν εξερχόμενες ακμές από έναν κόμβο, δεν μπορεί να φτάσει πουθενά": "If there are no outgoing edges from a node, it cannot reach anywhere",
    "Όλοι: A, B, C, D": "All: A, B, C, D",
    "Μόνο ο D": "Only D",
    "Οι D και C": "D and C",
    "Οι D, C και B": "D, C and B",
    "Την τελευταία συγκρινόμενη τιμή": "The last compared value",
    "Μηδέν": "Zero",
    "None ή NIL": "None or NIL",
    "Exception": "Exception",
    "Στο δεξί του 30": "To the right of 30",
    "Στο δεξί του 20": "To the right of 20",
    "Στο αριστερό του 20": "To the left of 20",
    "Ο κόμβος έχει τρία παιδιά": "The node has three children",
    "Ο κόμβος είναι φύλλο": "The node is a leaf",
    "Ο κόμβος έχει δύο παιδιά": "The node has two children",
    "Ο κόμβος έχει ένα παιδί": "The node has one child",
    "Αντικαθιστούμε τον κόμβο με τον πατέρα του": "Replace the node with its parent",
    "Αντικαθιστούμε με οποιοδήποτε φύλλο": "Replace with any leaf",
    "Αντικαθιστούμε με το μέσο στοιχείο": "Replace with the average element",
    "Αντικαθιστούμε με τον in-order διάδοχο": "Replace with the in-order successor",
    "Όταν το BST είναι πλήρες": "When the BST is full",
    "Όταν το δέντρο είναι εκφυλισμένο": "When the tree is degenerate",
    "Όταν περιέχει 1000 κόμβους": "When it contains 1000 nodes",
    "Όταν έχει μόνο ρίζα": "When it only has a root",
    "Ο γονέας του 15": "The parent of 15",
    "Ο 20": "20",
    "Ο ελάχιστος του δεξιού υποδέντρου": "The minimum of the right subtree",
    "Κανένας – διαγράφεται ολόκληρο το δέντρο": "None – the entire tree is deleted",
    "Διάσχιση κατά επίπεδα (BFS)": "Level-order traversal (BFS)",
    "Συγκρίσεις τιμών": "Value comparisons",
    "Έλεγχος κενών παιδιών": "Checking for empty children",
    "Δομή ουράς": "Queue structure",
    "Η διατήρηση της διάταξης των τιμών": "Maintaining the order of values",
    "Η αύξηση του ύψους": "The increase in height",
    "Η διατήρηση της πληρότητας και της συμμετρίας": "Maintaining fullness and symmetry",
    "Η ταξινόμηση των κόμβων": "Sorting the nodes",
    "Αντικατάσταση με τελευταίο κόμβο": "Replacement with the last node",
    "Αντικατάσταση με ρίζα": "Replacement with the root",
    "Αντικατάσταση με in-order διάδοχο": "Replacement with the in-order successor",
    "Η αποφυγή κενών θέσεων μεταξύ επιπέδων": "Avoiding empty positions between levels",
    "Η χρήση της τιμής του νέου κόμβου για συγκρίσεις": "Using the value of the new node for comparisons",
    "Η χρήση ουράς για BFS": "Using a queue for BFS",
    "Η προσθήκη ως φύλλο": "Adding as a leaf",
    "Το δέντρο γίνεται AVL": "The tree becomes AVL",
    "Οι κόμβοι επαναφέρονται αυτόματα": "Nodes are restored automatically",
    "Το δέντρο γίνεται εξισορροπημένο": "The tree becomes balanced",
    "Το δέντρο μετατρέπεται σε μονόπλευρη λίστα": "The tree is converted to a single-sided list",
    "Ο κόμβος παραμένει στο δέντρο με ειδική σημαία": "The node remains in the tree with a special flag",
    "Το παιδί του κόμβου τον αντικαθιστά": "The child of the node replaces it",
    "Το παιδί του μεταφέρεται στο root": "Its child is moved to the root",
    "Το δέντρο γίνεται αυτόματα ισοζυγισμένο": "The tree automatically becomes balanced",
    "Η διαγραφή μπορεί να αλλάξει τη σειρά in-order ταξινόμησης": "Deletion can change the in-order sorting order",
    "Αν ο κόμβος είναι φύλλο, απλώς αφαιρείται": "If the node is a leaf, it is simply removed",
    "Αν έχει δύο παιδιά, πάντα επιλέγουμε τον in-order διάδοχο": "If it has two children, we always choose the in-order successor",
    "Αν έχει μόνο ένα παιδί, το παιδί τον αντικαθιστά": "If it has only one child, the child replaces it",
    "Εμφανίζει αυξημένο ύψος και υποβαθμισμένη απόδοση": "Shows increased height and degraded performance",
    "Δεν υποστηρίζει in-order traversal": "Does not support in-order traversal",
    "Εισαγωγή στοιχείου μεγαλύτερου από όλα τα υπάρχοντα": "Insertion of an element greater than all existing ones",
    "Ανταλλαγή δύο κόμβων με ίσες τιμές": "Exchange of two nodes with equal values",
    "Αντικατάσταση ρίζας με in-order διάδοχο": "Replacement of root with in-order successor",
    "7": "7",
    "40": "40",
    "Η αναζήτηση σε συγκεκριμένη θέση απαιτεί διάσχιση της λίστας": "Searching at a specific position requires traversing the list",
    "Η εισαγωγή κόμβων απαιτεί μετακίνηση όλων των στοιχείων": "Node insertion requires moving all elements (Array weakness)",
    "Κάθε κόμβος αποθηκεύει μόνο δεδομένα": "Each node stores only data",
    "Η δομή απαιτεί λιγότερη μνήμη από έναν πίνακα": "The structure requires less memory than an array",
    "Ο τελευταίος κόμβος": "The last node",
    "Ο head": "The head",
    "Ο επόμενος του κόμβου προς διαγραφή": "The next node of the node to be deleted",
    "Ο κόμβος προς διαγραφή και ο προηγούμενός του": "The node to be deleted and its previous one",
    "Θέτουμε τον head να δείχνει στον επόμενο κόμβο": "We set head to point to the next node",
    "Θέτουμε τον head σε NULL": "We set head to NULL",
    "Απλώς απελευθερώνουμε τη μνήμη χωρίς να αλλάξουμε head": "We just free the memory without changing head",
    "Δεν διαγράφουμε τίποτα": "We delete nothing",
    "Επειδή ο προηγούμενος περιέχει τα δεδομένα": "Because the previous one contains the data",
    "Επειδή πρέπει να τον παρακάμψουμε στον δείκτη next": "Because we must bypass it in the next pointer",
    "Επειδή χρειαζόμαστε τις συντεταγμένες του": "Because we need its coordinates",
    "Επειδή ο προηγούμενος περιέχει την τιμή NULL": "Because the previous one contains the NULL value",
    "Ενημέρωση του head": "Updating the head",
    "Διαγραφή του temp": "Deleting the temp (the node itself)",
    "Αναζήτηση του προηγούμενου κόμβου": "Searching for the previous node",
    "Ο τελευταίος κόμβος διαγράφεται": "The last node is deleted",
    "Προκαλείται σφάλμα πρόσβασης (null pointer exception)": "An access error occurs (null pointer exception)",
    "Η λίστα μετατρέπεται σε πίνακα": "The list is converted to an array",
    "Δημιουργείται νέος head": "A new head is created",
    "Επισκέπτεται πρώτα τα φύλλα": "Visits leaves first",
    "Εξερευνά κάθε κλάδο ως το τέλος": "Explores each branch to the end (DFS)",
    "Εξερευνά πρώτα όλα τα επίπεδα από αριστερά προς τα δεξιά": "Explores all levels first from left to right (BFS)",
    "Χρησιμοποιεί αναδρομή": "Uses recursion (DFS)",
    "Preorder": "Preorder",
    "Inorder": "Inorder",
    "BFS": "BFS",
    "Postorder": "Postorder",
    "Επιστρέφει False": "Returns False",
    "Επιστρέφει λάθος": "Returns error",
    "Εισέρχεται σε άπειρο βρόχο": "Enters infinite loop",
    "Επιστρέφει True": "Returns True",
    "Εκτύπωση του δέντρου σε ταξινομημένη σειρά": "Printing the tree in sorted order (Inorder Traversal)",
    "Εύρεση του πρώτου κόμβου": "Finding the first node",
    "Δημιουργία αντίγραφου": "Creating a copy",
    "Διαγραφή του δέντρου": "Deleting the tree",
    "Τουλάχιστον 7": "At least 7",
    "Το πολύ 2": "At most 2",
    "Όλους": "All of them",
    "Μέχρι να τον βρει την πρώτη φορά": "Until it finds it the first time",
    "Μόνο φύλλα": "Leaves only",
    "Πάντα επιστρέφει False": "Always returns False",
    "DFS Preorder": "DFS Preorder",
    "DFS Inorder": "DFS Inorder",
    "DFS Postorder": "DFS Postorder",
    "Δεδομένα": "Data",
    "Δείκτης στον επόμενο κόμβο": "Pointer to the next node",
    "Δείκτης στον κόμβο με τη μέγιστη τιμή": "Pointer to the node with the maximum value",
    "Δείκτης στον προηγούμενο κόμβο": "Pointer to the previous node",
    "Όταν θέλουμε εύκολη διαγραφή χωρίς προηγούμενο κόμβο": "When we want easy deletion without a previous node",
    "Όταν θέλουμε τυχαία πρόσβαση": "When we want random access",
    "Όταν θέλουμε σταθερή πρόσβαση με δείκτες": "When we want constant access with pointers",
    "Όταν οι τιμές είναι ταξινομημένες": "When values are sorted",
    "Η λίστα θα αγνοήσει το λάθος": "The list will ignore the error",
    "Θα δημιουργηθεί κύκλος": "A cycle will be created",
    "Η επιστροφή προς τα πίσω δεν θα λειτουργεί σωστά": "Backward movement will not work correctly",
    "Ο δείκτης next θα γίνει NULL": "The next pointer will become NULL",
    "Δέντρα": "Trees",
    "Στοίβα (stack)": "Stack",
    "Πίνακας μεταβλητών": "Variable array",
    "Κυκλικό ιστορικό (π.χ. undo-redo)": "Circular history (e.g., undo-redo)",
    "Ο επόμενος κόμβος πρέπει να δείχνει στον εαυτό του": "The next node must point to itself",
    "Ο next του προηγούμενου κόμβου δείχνει στον επόμενο, και ο prev του επόμενου κόμβου δείχνει στον προηγούμενο": "The next of the previous node points to the next, and the prev of the next node points to the previous",
    "Ο προηγούμενος κόμβος πρέπει να δείχνει σε NULL": "The previous node must point to NULL",
    "Ο head και tail πρέπει να αντιστραφούν": "Head and tail must be reversed",
    "Ο νέος κόμβος θα γίνει head χωρίς πρόβλημα": "The new node will become head without issue",
    "Ο target θα χάσει τη σύνδεση με τον προηγούμενο κόμβο": "The target will lose connection with the previous node",
    "Ο newNode->next θα γίνει NULL": "newNode->next will become NULL",
    "Η λίστα θα συνεχίσει να λειτουργεί κανονικά": "The list will continue to function normally",
    "Ορίζουμε τον νέο κόμβο ως tail": "Define the new node as tail",
    "Διαγράφουμε τον προηγούμενο κόμβο": "Delete the previous node",
    "Διατρέχουμε τη λίστα μέχρι να φτάσουμε στη σωστή θέση": "Traverse the list until we reach the correct position",
    "Θέτουμε newNode->prev = NULL": "Set newNode->prev = NULL",
    "Πάντα, ανεξαρτήτως θέσης": "Always, regardless of position",
    "Όταν εισάγουμε στην αρχή της λίστας": "When inserting at the beginning of the list",
    "Όταν εισάγουμε σε ενδιάμεση θέση": "When inserting at an intermediate position",
    "Όταν εισάγουμε στο τέλος της λίστας": "When inserting at the end of the list",
    "head = NULL και newNode->prev = tail": "head = NULL and newNode->prev = tail",
    "head = newNode και newNode->prev = NULL": "head = newNode and newNode->prev = NULL",
    "tail->next = newNode": "tail->next = newNode",
    "newNode->next = tail": "newNode->next = tail",
    "Επειδή εξαλείφει την ανάγκη ενημέρωσης δεικτών": "Because it eliminates the need to update pointers",
    "Επειδή δεν χρειάζεται να διασχίσουμε τη λίστα": "Because we do not need to traverse the list",
    "Επειδή ο tail δείχνει στον head": "Because tail points to head",
    "Επειδή μειώνεται η κατανάλωση μνήμης": "Because memory consumption is reduced",
    "Επειδή αλλιώς ο νέος κόμβος θα έχει NULL δείκτες": "Because otherwise the new node will have NULL pointers",
    "Επειδή αλλιώς μπορεί να δημιουργηθεί κύκλος στη λίστα": "Because otherwise a cycle may be created in the list",
    "Για να διατηρηθεί η σωστή αμφίδρομη σύνδεση μεταξύ των κόμβων": "To maintain the correct bidirectional connection between nodes",
    "Για να ελευθερωθεί μνήμη από τον παλιό κόμβο": "To free memory from the old node",
    "Υ → 1 → 2 → Χ → 3 → Z": "Y → 1 → 2 → X → 3 → Z",
    "1 → Υ → 2 → Χ → 3 → Z": "1 → Y → 2 → X → 3 → Z",
    "Υ → 1 → 2 → 3 → Χ → Z": "Y → 1 → 2 → 3 → X → Z",
    "Υ → 1 → 2 → Χ → Z": "Y → 1 → 2 → X → Z",
    "Ξεχνάμε να ενημερώσουμε το prev του target->next": "Forgetting to update the prev of target->next",
    "Ορίζουμε newNode->next = NULL όταν εισάγουμε στη μέση": "Setting newNode->next = NULL when inserting in the middle",
    "Εισάγουμε στην αρχή χωρίς να αλλάξουμε το head": "Inserting at the beginning without changing the head",
    "Και οι επιλογές Α και Γ": "Both options A and C",
    "Δεν αλλάζουμε τίποτα": "We do not change anything",
    "Ορίζουμε current->next->prev = current->prev": "We set current->next->prev = current->prev (Correct for deletion)",
    "Ορίζουμε current->prev->next = current": "We set current->prev->next = current",
    "Ορίζουμε current->prev = NULL": "We set current->prev = NULL",
    "Ο κόμβος προς διαγραφή είναι ο head": "The node to be deleted is the head",
    "Ο κόμβος βρίσκεται στη μέση": "The node is in the middle",
    "Ο 20.next δείχνει στον 40, και ο 40.prev δείχνει στον 20": "20.next points to 40, and 40.prev points to 20",
    "Ο 30.prev δείχνει στον 40": "30.prev points to 40",
    "Ο 40.next δείχνει στον 20": "40.next points to 20",
    "Καμία σύνδεση δεν αλλάζει": "No connection changes",
    "head = tail = NULL": "head = tail = NULL",
    "head = 100, tail = NULL": "head = 100, tail = NULL",
    "head = NULL, tail = 100": "head = NULL, tail = 100",
    "Η λίστα παραμένει ίδια": "The list remains the same",
    "H.next = NULL, L.prev = NULL": "H.next = NULL, L.prev = NULL",
    "H.next = E, L.prev = E": "H.next = E, L.prev = E",
    "H.next = L, L.prev = H": "H.next = L, L.prev = H",
    "H.next = O, O.prev = H": "H.next = O, O.prev = H",
    "Ενημέρωση του next->prev": "Updating next->prev",
    "Ενημέρωση του prev->next": "Updating prev->next",
    "Ορισμός νέου tail ανεξαρτήτως θέσης": "Defining new tail regardless of position",
    "2.next = 99, 99.prev = 2, 99.next = 4, 4.prev = 99": "2.next = 99, 99.prev = 2, 99.next = 4, 4.prev = 99",
    "2.next = 4, 4.prev = 2": "2.next = 4, 4.prev = 2",
    "2.next = 99, 4.next = 99": "2.next = 99, 4.next = 99",
    "99.next = 2, 2.prev = 99": "99.next = 2, 2.prev = 99",
    "A <-> B <-> D <-> E": "A <-> B <-> D <-> E",
    "B <-> D": "B <-> D",
    "A <-> B <-> C": "A <-> B <-> C",
    "D μόνος του": "D alone",
    "Η επαναληπτική χρησιμοποιεί stack calls, η αναδρομική όχι": "Iterative uses stack calls, recursive does not (Incorrect)",
    "Η αναδρομική είναι πιο εύκολη στην υλοποίηση αλλά μπορεί να καταναλώσει περισσότερη μνήμη": "Recursive is easier to implement but may consume more memory (Stack memory)",
    "Η επαναληπτική δεν μπορεί να βρει στοιχεία που είναι στο τέλος": "Iterative cannot find elements at the end",
    "Η αναδρομική δεν επιστρέφει τον κόμβο που βρέθηκε": "Recursive does not return the found node",
    "Το τελευταίο στοιχείο": "The last element",
    "Το head της λίστας": "The head of the list",
    "Από το head, γιατί έτσι γίνεται πάντα η αναζήτηση σε DLL": "From the head, because that is how searching is always done in DLL",
    "Από το tail, γιατί είναι πιο κοντά στο στοιχείο 7": "From the tail, because it is closer to element 7 (DLL Advantage)",
    "Από τη μέση της λίστας": "From the middle of the list",
    "Από τον head, με prev": "From the head, using prev",
    "Από τον tail, με prev": "From the tail, using prev",
    "Από τον head, με next": "From the head, using next",
    "Όταν η DLL έχει περισσότερους από 2 κόμβους": "When the DLL has more than 2 nodes",
    "Όταν η λίστα είναι ταξινομημένη": "When the list is sorted",
    "Όταν η αναζήτηση ξεκινά πάντα από το head και δεν χρειάζεται να κινηθούμε προς τα πίσω": "When search always starts from the head and we don't need to move backwards",
    "Όταν η αναζήτηση γίνεται επαναληπτικά": "When search is done iteratively",
    "Λάθος στη συνθήκη τερματισμού": "Error in the termination condition",
    "Υπερχείλιση της στοίβας κλήσεων (stack overflow)": "Stack overflow",
    "Η DLL είναι κυκλική": "The DLL is circular",
    "Λανθασμένη τροποποίηση δεικτών": "Incorrect pointer modification",

    // --- Graph Concepts ---
    "Η ύπαρξη μονοπατιού από κάθε κόμβο σε κάθε άλλον": "The existence of a path from every node to every other node",
    "Η κατεύθυνση των ακμών παίζει ρόλο": "The direction of the edges plays a role (Directed Graph)",
    "Ένας κόμβος μπορεί να έχει τόσο εισερχόμενες όσο και εξερχόμενες ακμές": "A node can have both incoming and outgoing edges",
    "Ο γράφος μπορεί να περιέχει κύκλους": "The graph can contain cycles",
    "Πίνακας γειτνίασης (adjacency matrix)": "Adjacency matrix",
    "Λίστα γειτνίασης (adjacency list": "Adjacency list",
    "Μήτρα απόστασης": "Distance matrix",
    "Πίνακας incident ακμών": "Incident edges table",
    "n²": "n²",
    "n(n-1)": "n(n-1)",
    "n(n+1)": "n(n+1)",
    "n/2": "n/2",
    "Κάθε κόμβος πρέπει να έχει τουλάχιστον μία ακμή": "Every node must have at least one edge",
    "Οι ακμές δεν έχουν κατεύθυνση": "Edges have no direction (Undirected Graph)",
    "Μπορούν να υπάρχουν ακμές που ξεκινούν και καταλήγουν στον ίδιο κόμβο": "Edges can start and end at the same node (Self-loop)",
    "Δεν μπορούν να υπάρχουν κύκλοι": "Cycles cannot exist",
    "Το πλήθος των εισερχόμενων ακμών": "The number of incoming edges (Indegree)",
    "Το πλήθος των εξερχόμενων ακμών": "The number of outgoing edges (Outdegree)",
    "Το άθροισμα των βαρών των ακμών": "The sum of edge weights",
    "Το σύνολο των κόμβων που τον συνδέουν άμεσα": "The set of nodes that directly connect to it",
    "Πλήρης γράφος": "Complete graph",
    "Κυκλικός γράφος": "Circular graph",
    "Μη συνεκτικός γράφος": "Non-connected graph",
    "Δέντρο": "Tree (Acyclic)",
    "Λίστα γειτνίασης": "Adjacency list",
    "Πίνακας γειτνίασης": "Adjacency matrix",
    "Ο(1)": "O(1)",
    "O(n)": "O(n)",
    "O(n²)": "O(n²)",
    "O(log n)": "O(log n)",
    "O(log n)": "O(log n)",
    "mid = (left + right) // 2": "mid = (left + right) // 2",
    "Διαγραφή όλου του υποδέντρου": "Deletion of the entire subtree",
    "Σταθερή απόδοση O(log n)": "Stable performance of O(log n)",
    "Η χρήση δεικτών": "The use of pointers",
    "Η ύπαρξη ισορροπίας μέσω του balance factor": "The existence of balance via the balance factor",
    "Η χρήση ενδοδιάταξης": "The use of in-order traversal",
    "Η δυνατότητα αναζήτησης": "The ability to search",
    "Παραμένει άθικτο": "Remains intact",
    "Εισάγεται νέος κόμβος": "A new node is inserted",
    "Το παιδί του successor παίρνει τη θέση του": "The successor's child takes its place",
    "Το δέντρο ισοπεδώνεται": "The tree is flattened",
    "Διορθώνουμε τον πλησιέστερο κόμβο στη διαγραφή και συνεχίζουμε προς τα πάνω": "We fix the node closest to the deletion and continue upwards",
    "Εφαρμόζουμε περιστροφή μόνο στον πιο απομακρυσμένο κόμβο": "We apply rotation only to the most distant node",
    "Ελέγχουμε όλους τους κόμβους ξεκινώντας από τη ρίζα": "We check all nodes starting from the root",
    "Εφαρμόζουμε δεξιά περιστροφή σε κάθε μη ισορροπημένο κόμβο": "We apply a right rotation to every unbalanced node",
    "index += 1": "index += 1",
    "left = mid + 1": "left = mid + 1",
    "right = mid - 1": "right = mid - 1",
    "O(n log n)": "O(n log n)",
    "O(logn)": "O(logn)",
    "O(nlogn)": "O(nlogn)",
    "insert": "insert",
    "Δίπλα στη ρίζα": "Next to the root",
    "Στον τελευταίο κόμβο": "At the last node",
    "Την Python": "Python",
    "Τον εαυτή της": "Itself",
    "Εξαρτάται από την υλοποίηση": "It depends on the implementation",
    "Προσθέτει νέα στοιχεία": "It adds new elements",
    "Δυαδική Αναζήτηση": "Binary search",
    "Πάντα": "Always",
    "Εισαγωγή νέου στοιχείου": "Insertion of a new element",
    "Κάθε κόμβος δείχνει στον επόμενο": "Each node points to the next one",
    "Μπορούμε να μεταβούμε εύκολα από το τέλος προς την αρχή": "We can easily move from the end to the beginning",
    "Δεν απαιτείται συνεχόμενος χώρος στη μνήμη": "Contiguous memory space is not required",
    "Μπορεί να επεκταθεί δυναμικά": "It can be dynamically extended",
    "Δείχνει στον πρώτο κόμβο": "Points to the first node",
    "Είναι δείκτης null": "It is a null pointer",
    "Δείχνει στον εαυτό του": "Points to itself",
    "Δείχνει σε τυχαία θέση μνήμης": "Points to a random memory location",
    "Αντικατάσταση της ρίζας με το τελευταίο στοιχείο": "Replacement of the root with the last element",
    "Το νέο στοιχείο στη ρίζα είναι το μικρότερο από τα παιδιά": "The new element at the root is the smallest of the children",
    "Τον πίνακα": "The array",
    "Την εντολή return": "The return statement",
    "Όταν είναι μεγάλος": "When it is large",
    "Η χρήση πίνακα για δείκτες": "The use of an array for pointers",
    "Η ύπαρξη μεταβλητού τύπου δεδομένω": "The existence of a variable data type",
    "Η μεταβλητή μήκους λίστας": "The variable list length",
    "Σταθερό μέγεθος": "Fixed size",
    "Όταν απαιτείται συχνή εισαγωγή/διαγραφή": "When frequent insertion/deletion is required",
    "Όταν το μέγεθος της δομής είναι άγνωστο εκ των προτέρων": "When the size of the structure is unknown beforehand",
    "Όταν απαιτείται άμεση πρόσβαση σε τυχαίες θέσεις": "When direct access to random positions is required",
    "Όταν η χρήση μνήμης πρέπει να είναι αποδοτική": "When memory usage must be efficient",
    "Παρέχουν πρόσβαση με σταθερό χρόνο (O(1))": "They provide constant time access (O(1))",
    "A": "A",
    "B": "B",
    "D": "D",
    "Δημιουργεί μεγάλα blocks clustering": "It creates large blocks of clustering",
    "Χρησιμοποιεί την ίδια συνάρτηση h(k) δύο φορές": "It uses the same function h(k) twice",
    "Δουλεύει μόνο όταν ο πίνακας είναι πλήρως άδειος": "It works only when the table is completely empty",
    "Χρησιμοποιεί δεύτερη συνάρτηση για καλύτερη κατανομή": "It uses a second function for better distribution",
    "Linear Probing": "Linear Probing",
    "Quadratic Probing": "Quadratic Probing",
    "Double Hashing": "Double Hashing",
    "Το στοιχείο θα αναζητείται κανονικά": "The element will be searched normally",
    "Αγνόηση των DELETED κατά την αναζήτηση": "Ignoring DELETED during search",
    "Δεν υπάρχει καμία συνέπεια": "There is no consequence",
    "Όταν front == rear": "When front == rear",
    "(rear + 1) % size == front": "(rear + 1) % size == front",
    "Όταν η ουρά είναι άδεια": "When the queue is empty",
    "front == rear": "front == rear",
    "Η ουρά είναι κενή": "The queue is empty",
    "Σφάλμα δείκτη": "Pointer error",
    "Δεν υποστηρίζει διαγραφή": "It does not support deletion",
    "Παράγει λανθασμένα αποτελέσματα": "It produces incorrect results",
    "push()": "push()",
    "True": "True",
    "Διαγραφή ενός κόμβου": "Deletion of a node",
    "AVL": "AVL",
    "Πλήρες": "Complete",
    "Επιστρέφει το μέγιστο στοιχείο": "It returns the maximum element",
    "Hash Table": "Hash Table",
    "Stack": "Stack",
    "Στοίβα: [3, 9], top=1": "Stack: [3, 9], top=1",
    "Στοίβα: [3, 4, 7, 9], top=2": "Stack: [3, 4, 7, 9], top=2",
    "Στοίβα: [3, 4, 9], top=2": "Stack: [3, 4, 9], top=2",
    "Στοίβα: [3, 4, 9], top=1": "Stack: [3, 4, 9], top=1",
    "Όταν front == -1": "When front == -1",
    "Όταν rear == size - 1": "When rear == size - 1",
    "Σφάλμα": "Error",
    "malloc(top)": "malloc(top)",
    "top = NULL;": "top = NULL;",
    "MAX_SIZE": "MAX_SIZE",
    "Η συνολική πολυπλοκότητα θα είναι O(100 × n)": "The total complexity will be O(100 x n)",
    "Θα χρειαστούν O(100) προσπελάσεις": "O(100) accesses will be required",
    "Η πολυπλοκότητα θα είναι συνολικά O(1)": "The overall complexity will be O(1)",
    "Η πολυπλοκότητα δεν επηρεάζεται": "The complexity is not affected",
    "Αν ο κόμβος έχει αρνητική τιμή": "If the node has a negative value",
    "Αν η λίστα είναι κενή": "If the list is empty",
    "Να ελέγξουμε αν η λίστα είναι κενή (head == NULL)": "To check if the list is empty (head == null)",
    "Εκτύπωση δεδομένων": "Printing data",
    "Απλή και ευανάγνωστη υλοποίηση": "Simple and readable implementation",
    "Μικρότερη κατανάλωση μνήμης": "Lower memory consumption",
    "Δεν προκαλεί υπερχείλιση στοίβας": "Does not cause stack overflow",
    "Σταθερή χρήση μνήμης ανεξαρτήτως μεγέθους": "Stable memory usage regardless of size",
    "Έλεγχος για πολλαπλές εμφανίσεις": "Checking for multiple occurrences",
    "Όταν φτάσουμε στον τελευταίο κόμβο": "When we reach the last node",
    "Όταν ο δείκτης γίνει NULL ή βρεθεί το στοιχείο": "When the pointer becomes NULL or the element is found",
    "Όταν συγκρίνουμε όλους τους κόμβους": "When we compare all nodes",
    "Όταν η λίστα έχει λιγότερους από 3 κόμβους": "When the list has fewer than 3 nodes",
    "Σύγκριση current->data με την τιμή αναζήτησης": "Comparing current->data with the search value",
    "Αναδρομική κλήση": "Recursive call",
    "Να δημιουργηθεί δείκτης tail": "To create a tail pointer",
    "Να ταξινομηθεί η λίστα": "To sort the list",
    "Να μετατραπεί σε πίνακα": "To convert it to an array",
    "Το μέγεθος του κόμβου αυξάνεται": "The size of the node increases",
    "Χρειάζεται αλλαγή όλων των τιμών": "Changing all values is necessary",
    "Κάθε θέση απαιτεί επιπλέον μνήμη": "Each position requires additional memory",
    "Αν η λίστα έχει αρνητικά δεδομένα": "If the list has negative data",
    "Αν η λίστα είναι κενή": "If the list is empty",
    "Αν η θέση είναι ζυγός αριθμός": "If the position is an even number",
    "Αν ο δείκτης tail είναι NULL": "If the tail pointer is NULL",
    "Πρέπει να διασχίσουμε τους κόμβους μέχρι τη θέση k-1": "We must traverse the nodes up to position k-1",
    "Αν η λίστα έχει περιττό αριθμό κόμβων": "If the list has an odd number of nodes",
    "Δεν μπορεί να γίνει": "It can not happen",
    "Μετρητής αναδρομής": "Recursion counter",
    "Ο κόμβος είναι NULL": "The node is NULL",
    "Ο κόμβος περιέχει το ζητούμενο στοιχείο": "The node contains the sought element",
    "Αναδρομική αναζήτηση": "Recursive search",
    "Επαναληπτική αναζήτηση": "Iterative search",
    "Επιστροφή true/false": "Returning true/false",
    "Χρήση λογικού τελεστή": "Using a logical operator",
    "Η αναζήτηση σε απλή λίστα έχει πολυπλοκότητα O(n) στη χειρότερη περίπτωση": "Search in a simple list has O(n) complexity in the worst case",
    "Η αναδρομική αναζήτηση είναι πάντα πιο γρήγορη": "Recursive search is always faster",
    "Η αναζήτηση σε λίστα έχει πολυπλοκότητα O(log n)": "Search in a list has O(n logn) complexity",
    "Η αναζήτηση αλλάζει τη δομή της λίστας": "Search changes the structure of the list",
    "Αποθήκευση όλων των ταιριαστών κόμβων σε λίστα ή πίνακα": "Storing all matching nodes in a list or array",
    "Επιστροφή μόνο του πρώτου κόμβου": "Returning only the first node",
    "Χρήση πίνακα": "Use of an array",
    "Δυαδική αναζήτηση": "Binary search",
    "Έχουμε φτάσει στον τελευταίο κόμβο": "We have reached the last node",
    "Όλες οι παραπάνω είναι βάσεις": "All the above are base cases",
    "Δείκτης prev": "Prev pointer",
    "Δείκτης tail": "Tail pointer",
    "Δείκτης current που διατρέχει τη λίστα": "Current pointer that traverses the list",
    "Αν το head δείχνει στον τελευταίο κόμβο": "If the head points to the last node",
    "Το πλήθος των στοιχείων": "The number of elements",
    "Όταν rear + 1 == front": "When rear + 1 == front",
    "Εντοπισμός του τελευταίου κόμβου": "Locating the last node",
    "Δημιουργία νέου κόμβου": "Creation of a new node",
    "Ορισμός του head σε NULL": "Setting the head to NULL",
    "Ορισμός newNode->next = NULL": "Setting newNode->next = NULL",
    "Ορισμός tail στον νέο κόμβο": "Setting tail to the new node",
    "Ενημέρωση του head να δείχνει στον νέο κόμβο": "Updating the head to point to the new node",
    "Δημιουργούμε νέο tail": "We create a new tail",
    "Αγνοούμε την εισαγωγή": "We ignore the insertion",
    "Εκτελούμε εισαγωγή στην αρχή": "We perform insertion at the beginning",
    "Τοποθετούμε τον κόμβο στη μέση της λίστας": "We place the node in the middle of the list",
    "Επαναφορά του προηγούμενου head": "Restoring the previous head",
    "Διαγραφή κάποιου υπάρχοντος κόμβου": "Deletion of an existing node",
    "Έλεγχος αν η λίστα είναι κενή": "Check if the list is empty",
    "Υποστηρίζουν δυναμική κατανομή και αποδέσμευση μνήμης": "They support dynamic memory allocation and deallocation",
    "Δεσμεύουν σταθερό μέγεθος πίνακα για αποθήκευση": "They allocate a fixed array size for storage",
    "Διατηρούν τα δεδομένα σε συνεχόμενες περιοχές μνήμης": "They keep data in contiguous memory regions",
    "Άμεση πρόσβαση σε κάθε θέση": "Direct access to every position",
    "Ευκολία στην εισαγωγή και διαγραφή": "Ease of insertion and deletion",
    "Μικρότερη χρήση μνήμης ανά στοιχείο": "Lower memory usage per element",
    "Η δυνατότητα τροποποίησης των δεικτών": "The ability to modify the pointers",
    "Όταν δεν είναι ταξινομημένος": "When it is not sorted (Binary Search requirement)",
    "Όταν περιέχει strings": "When it contains strings",
    "Όταν λείπει το mid": "When mid is missing",
    "Το στοιχείο βρέθηκε": "The element was found",
    "Υπάρχει loop": "There is a loop",
    "Ο πίνακας ταξινομήθηκε": "The array was sorted",
    "Η αναζήτηση απέτυχε": "The search failed",
    "Πηγαίνει στο τέλος": "Goes to the end",
    "Ξεκινά νέα αναζήτηση": "Starts new search",
    "Απορρίπτει το αριστερό μισό": "Rejects the left half",
    "Ψάχνει πίσω": "Searches backwards",
    "value > 10": "value > 10",
    "value == 'target'": "value == 'target'",
    "value in array": "value in array",
    "value % 2 == 0": "value % 2 == 0",
    "O(n log n)": "O(n log n)",
    "Πολύ γρήγορος": "Very fast",
    "Εύκολος στην κατανόηση": "Easy to understand",
    "Πολύπλοκος αλλά αποτελεσματικός": "Complex but efficient",
    "Χρειάζεται λίγη μνήμη": "Needs little memory",
    "Selection Sort": "Selection Sort",
    "Merge Sort": "Merge Sort",
    "Quick Sort": "Quick Sort",
    "Shell Sort": "Shell Sort",
    "Θέλει πολύ μνήμη": "Needs a lot of memory",
    "Δεν είναι in-place": "Is not in-place",
    "Πάντα έχει πολυπλοκότητα O(n²)": "Always has O(n²) complexity",
    "Δεν ταξινομεί αριθμού": "Does not sort numbers",
    "Bubble Sort": "Bubble Sort",
    "Counting Sort": "Counting Sort",
    "Insertion Sort": "Insertion Sort",
    "Όταν έχει περάσει από τον πίνακα 2 φορές": "When it has passed through the array 2 times",
    "Όταν δεν υπάρχουν ανταλλαγές": "When there are no swaps",
    "Όταν το πρώτο στοιχείο είναι το μεγαλύτερο": "When the first element is the largest",
    "Όταν φτάσει στη μέση του πίνακα": "When it reaches the middle of the array",
    "[2, 3, 1, 5]": "[2, 3, 1, 5]",
    "[1, 2, 3, 5]": "[1, 2, 3, 5]",
    "[5, 3, 2, 1]": "[5, 3, 2, 1]",
    "[5, 1, 3, 2]": "[5, 1, 3, 2]",
    "[10, 7], 5, [1, 8, 9]": "[10, 7], 5, [1, 8, 9]",
    "[10, 9], 5, [7, 8, 1]": "[10, 9], 5, [7, 8, 1]",
    "[7, 8], 5, [1, 9, 10]": "[7, 8], 5, [1, 9, 10]",
    "[1], 5, [10, 7, 8, 9]": "[1], 5, [10, 7, 8, 9]",
    "Τίποτα, όπως στον κατευθυνόμενο": "Nothing, as in the directed graph",
    "Να προσθέσουμε τη σύνδεση και στα δύο άκρα": "To add the connection at both ends",
    "Να δημιουργήσουμε νέα δομή": "To create a new structure",
    "Να χρησιμοποιήσουμε DFS": "To use DFS",
    "Το αν μπορείς να πας από έναν κόμβο σε όλους τους άλλους": "Whether you can go from one node to all others",
    "Ο τρόπος με τον οποίο εισάγονται οι κόμβοι": "The way nodes are inserted",
    "Το μέγεθος του γράφου": "The size of the graph",
    "Ο αριθμός των κόμβων": "The number of nodes",
    "Προσβάσιμοι μέσω εισερχόμενων ακμών": "Accessible via incoming edges",
    "Συνδεδεμένοι συμμετρικά": "Symmetrically connected",
    "Προσβάσιμοι μέσω εξερχόμενων ακμών": "Accessible via outgoing edges",
    "Κοντινοί στο σημείο εκκίνησης ανεξαρτήτως κατεύθυνσης": "Close to the starting point regardless of direction",
    "Συνδέει όλες τις κορυφές, σχηματίζοντας κύκλους": "Connects all vertices, forming cycles",
    "Συνδέει τις κορυφές με το μέγιστο δυνατό βάρος": "Connects vertices with the maximum possible weight",
    "Συνδέει όλες τις κορυφές χωρίς κύκλους και με το ελάχιστο συνολικό βάρος": "Connects all vertices without cycles and with the minimum total weight",
    "Αφορά μόνο κατευθυνόμενους γράφους": "Concerns only directed graphs",
    "Ξεκινά από μια κορυφή και επεκτείνεται": "Starts from a vertex and expands (Prim's)",
    "Επιλέγει ακμές από τη μικρότερη προς τη μεγαλύτερη, αποφεύγοντας κύκλους": "Selects edges from smallest to largest, avoiding cycles (Kruskal's)",
    "Βασίζεται σε DFS": "Is based on DFS",
    "Είναι κατάλληλος μόνο για πυκνούς γράφους": "Is suitable only for dense graphs",
    "Prim με Min Heap": "Prim with Min Heap",
    "Kruskal": "Kruskal",
    "Prim με απλό πίνακα": "Prim with simple array",
    "Όταν ο γράφος είναι πυκνός": "When the graph is dense",
    "Όταν οι ακμές είναι ταξινομημένες": "When edges are sorted",
    "Όταν ο γράφος είναι αραιός": "When the graph is sparse",
    "Όταν χρησιμοποιείται πίνακας γειτνίασης": "When an adjacency matrix is used",
    "{A–B, B–C}": "{A–B, B–C}",
    "{A–C, B–C}": "{A–C, B–C}",
    "{A–B, A–C}": "{A–B, A–C}",
    "{X–Y, Z–X}": "{X–Y, Z–X}",
    "{X–Y, Y–Z}": "{X–Y, Y–Z}",
    "{X–Y, Y–Z, Z–X}": "{X–Y, Y–Z, Z–X}",
    "{Y–Z, Z–X}": "{Y–Z, Z–X}",
    "size()": "size()",
    "clear()": "clear()",
    "contains()": "contains()",
    "toArray()": "toArray()",
    "Όταν τα στοιχεία δεν έχουν φυσική σειρά": "When elements do not have a natural order",
    "Όταν εισάγουμε ακέραιους αριθμούς": "When inserting integers",
    "Όταν συγκρίνουμε ίδιου τύπου Strings": "When comparing Strings of the same type",
    "Όταν προστίθενται αντικείμενα του ίδιου τύπου": "When objects of the same type are added",
    "Δεν υποστηρίζει λογικές πράξεις": "Does not support logical operations",
    "Είναι πιο αργό από HashSet": "It is slower than HashSet",
    "Δεν επιτρέπει strings": "Does not allow strings",
    "Δεν υλοποιεί την interface Set": "Does not implement the Set interface",
    "Δεν υλοποιεί Comparable": "Does not implement Comparable",
    "Δεν έχει hashCode": "Does not have hashCode",
    "Είναι μη μεταβλητό στοιχείο": "Is an immutable element",
    "Δεν μπορεί να συγκριθεί για ταξινόμηση": "Cannot be compared for sorting",
    "Το ότι βασίζεται σε πίνακες": "That it is based on arrays",
    "Το ότι αναδιατάσσει όλα τα στοιχεία σε κάθε προσθήκη": "That it rearranges all elements on every addition",
    "Το ότι διατηρεί ισορροπημένο δέντρο": "That it maintains a balanced tree (Red-Black Tree)",
    "Το ότι αποθηκεύει στοιχεία σε μορφή bytecode": "That it stores elements in bytecode form",
    "Γραμμικός χρόνος": "Linear time",
    "Λογαριθμικός χρόνος": "Logarithmic time",
    "Σταθερός χρόνος": "Constant time",
    "Πολυωνυμικός χρόνος": "Polynomial time",
    "Επιστρέφει null": "Returns null",
    "Επιστρέφει το πρώτο στοιχείο": "Returns the first element",
    "Πετιέται NoSuchElementException": "Throws NoSuchElementException",
    "Δεν συμβαίνει τίποτα": "Nothing happens",
    "Το μεγαλύτερο στοιχείο μικρότερο από το δοσμένο": "The largest element smaller than the given one (floor)",
    "Το μικρότερο στοιχείο μεγαλύτερο από το δοσμένο": "The smallest element greater than the given one (ceiling/higher)",
    "Το στοιχείο ίσο με το δοσμένο": "The element equal to the given one",
    "Το πρώτο στοιχείο στη σειρά": "The first element in the sequence",
    "floor()": "floor()",
    "higher()": "higher()",
    "lower()": "lower()",
    "ceiling()": "ceiling()",
    "Επιστρέφει το αμέσως μικρότερο στοιχείο": "Returns the element immediately smaller (lower)",
    "Επιστρέφει το ίδιο το στοιχείο": "Returns the element itself",
    "Η μέθοδος contains() έχει χρόνο O(n)": "The contains() method has O(n) time",
    "Η μέθοδος first() μπορεί να επιστρέψει null αν το TreeSet είναι κενό": "The first() method can return null if the TreeSet is empty",
    "Οι μέθοδοι higher() και lower() επιστρέφουν null όταν δεν υπάρχει κατάλληλο στοιχείο": "The higher() and lower() methods return null when there is no suitable element",
    "Το TreeSet επιτρέπει null στοιχεία": "TreeSet allows null elements (False in Java, True in C#)",
    "Red-Black Tree": "Red-Black Tree",
    "ArrayList": "ArrayList",
    "5 και 20": "5 and 20",
    "10 και 15": "10 and 15",
    "5 και 5": "5 and 5",
    "20 και 5": "20 and 5",
    "2 και 5": "2 and 5",
    "5 και null": "5 and null",
    "5 και 9": "5 and 9",
    "9 και 6": "9 and 6",
    "Αν ο γράφος είναι πυκνός": "If the graph is dense",
    "Αν ο γράφος είναι αραιός": "If the graph is sparse",
    "Αν το πλήθος των ακμών είναι κοντά στο μέγιστο δυνατό": "If the number of edges is close to the maximum possible",
    "Χρησιμοποιούμε πίνακα γειτνίασης για βέλτιστη απόδοση": "We use an adjacency matrix for optimal performance (Dense Graphs)",
    "Η λίστα γειτνίασης είναι πιο αποδοτική σε μνήμη": "The adjacency list is more memory efficient (Sparse Graphs)",
    "Το άθροισμα των μη μηδενικών στοιχείων στον πίνακα γειτνίασης είναι μικρό": "The sum of non-zero elements in the adjacency matrix is small",
    "Το πλήθος των ακμών είναι κοντά στο μέγιστο δυνατό": "The number of edges is close to the maximum possible",

    // --- Array/2D Array Concepts ---
    "Έχουν γραμμική, στατική δομή χωρίς σύνδεση μεταξύ στοιχείων": "They have a linear, static structure without connection between elements",
    "Μπορούν να περιέχουν μόνο μηδενικά": "They can contain only zeros",
    "Είναι πολύπλοκοι στη δήλωση": "They are complex to declare",
    "Δεν υποστηρίζουν αριθμητικές τιμές": "They do not support numerical values",
    "Διευκολύνεται η αποθήκευση αντικειμένων": "The storage of objects is facilitated",
    "Μπορούν να χρησιμοποιηθούν για JSON αρχεία": "They can be used for JSON files",
    "Δεν μπορούν να αποθηκεύσουν διαφορετικούς τύπους δεδομένων": "They cannot store different data types",
    "Επιτρέπεται η αποθήκευση μεταβλητού αριθμού στοιχείων": "Variable number of elements is allowed",
    "Ο πίνακας γίνεται δυναμικός αυτόματα": "The array becomes dynamic automatically",
    "Πρέπει να δεσμευτεί χώρος που μπορεί να μην χρειαστεί": "Space must be allocated that may not be needed",
    "Δεν μπορεί να εκτελεστεί κανένα πρόγραμμα": "No program can be executed",
    "Ο πίνακας εκτελείται αργά": "The array runs slowly",
    "Δυνατότητα γρήγορης προσπέλασης σε κάθε στοιχείο μέσω δείκτη": "Ability to quickly access every element via an index",
    "Αποθήκευση στοιχείων σε συνεχόμενες θέσεις μνήμης για καλύτερη απόδοση": "Storing elements in contiguous memory locations for better performance",
    "Ανάγκη αναδόμησης ή αναδιάταξης κατά την εισαγωγή ή διαγραφή στοιχείων": "Need for rebuilding or reordering during element insertion or deletion",
    "Ορισμός του τύπου των στοιχείων κατά τη δημιουργία του πίνακα": "Defining the type of elements when creating the array",
    "Οικονομικές συναλλαγές μεταξύ εταιρειών": "Financial transactions between companies",
    "Δίκτυο φιλίας μεταξύ χρηστών": "Friendship network between users (Undirected Graph)",
    "Διάγραμμα ροής εργασίας": "Workflow diagram",
    "Εξαρτήσεις μεταξύ αρχείων σε ένα πρόγραμμα": "Dependencies between files in a program (DAG)",
    "Το άθροισμα όλων των βαθμών είναι πάντα άρτιος αριθμός": "The sum of all degrees is always an even number",
    "Μπορεί να έχει πολλές συνδετικές συνιστώσες": "It can have many connected components",
    "Χρησιμοποιείται σε αλγόριθμους εύρεσης ελάχιστου καλυπτόμενου δέντρου": "Used in minimum spanning tree algorithms (Undirected, Weighted)",
    "13": "13",
    "15": "15",
    "8": "8",
    "int array[2][3] = {{1,2,3}, {4,5,6}};": "int array[2][3] = {{1,2,3}, {4,5,6}};",
    "int array[] = { {1,2}, {3,4} };": "int array[] = { {1,2}, {3,4} };",
    "array = [[1,2],[3,4]]": "array = [[1,2],[3,4]]",
    "0 έως 3 για τις γραμμές, 0 έως 4 για τις στήλες": "0 to 3 for rows, 0 to 4 for columns",
    "int a[3][4];": "int a[3][4];",
    "int c[2][2] = {{5,6}, {7,8}};": "int c[2][2] = {{5,6}, {7,8}};",
    "int d[2][3] = {1, 2, 3, 4, 5, 6};": "int d[2][3] = {1, 2, 3, 4, 5, 6};",
    "int b[][] = {{1, 2}, {3, 4}};": "int b[][] = {{1, 2}, {3, 4}};",
    "Εισαγωγή τιμής σε θέση [i][j] που είναι κενή": "Inserting a value at position [i][j] that is empty",
    "Αντικατάσταση τιμής σε θέση [i][j]": "Replacing a value at position [i][j]",
    "Εισαγωγή τιμής διατηρώντας τη σειρά στη γραμμή": "Inserting a value while maintaining the order in the row",
    "Ενημέρωση μετρητή ενεργών στοιχείων": "Updating the active element counter",
    "Ο έλεγχος ορίων του πίνακα": "Array boundary checking",
    "Η σειρά των στοιχείων": "The order of elements",
    "Ο αριθμός των ενεργών στοιχείων": "The number of active elements",
    "Η ανάγκη εύρεσης πρώτης κενής θέσης": "The need to find the first empty position",
    "Απλή αντικατάσταση": "Simple replacement",
    "Μετακινεί τιμές δεξιά στη γραμμή 2": "Moves values right in row 2",
    "Διαγράφει την τιμή": "Deletes the value",
    "Προσθέτει νέα γραμμή": "Adds a new row",
    "a[1][0]": "a[1][0]",
    "a[2][2]": "a[2][2]",
    "a[1][1]": "a[1][1]",
    "a[1][2]": "a[1][2]",
    "[[1,5,2],[3,4]]": "[[1,5,2],[3,4]]",
    "[[1,5],[2,3],[4]]": "[[1,5],[2,3],[4]]",
    "Το 1 μετακινείται δεξιά": "1 moves right",
    "Δεν είναι δυνατό λόγω σταθερού μεγέθους": "It is not possible due to fixed size",
    "[[1,9,3],[4,5,6]]": "[[1,9,3],[4,5,6]]",
    "[[1,2,3,9],[4,5,6]]": "[[1,2,3,9],[4,5,6]]",
    "[[1,2,3],[4,9,6]]": "[[1,2,3],[4,9,6]]",
    "[[9,1,2],[3,4,5]]": "[[9,1,2],[3,4,5]]",
    "Ολόκληρη η στήλη αναδιατάσσεται": "The entire column is rearranged",
    "Μειώνεται ο αριθμός γραμμών": "The number of rows is reduced",
    "Η θέση a[2][2] παίρνει τιμή π.χ. -1 ή None": "Position a[2][2] takes value e.g. -1 or None",
    "Όλα τα στοιχεία γίνονται 0": "All elements become 0",
    "Java": "Java",
    "Python": "Python",
    "C++": "C++",
    "C": "C",
    "Θα προστεθεί κανονικά": "It will be added normally",
    "Θα χαθεί το παλαιότερο": "The oldest one will be lost",
    "Θα γίνει realloc": "Realloc will happen",
    "Θα επιστραφεί σφάλμα": "An error will be returned",
    "Χαμηλό κόστος εισαγωγής": "Low insertion cost",
    "Μικρή κατανάλωση μνήμης": "Low memory consumption",
    "Άμεση προσπέλαση": "Direct access",
    "Υποστήριξη από πολλές γλώσσες": "Support from many languages",
    "Απαίτηση συνεχόμενης μνήμης": "Requirement for contiguous memory",
    "Στατική μνήμη": "Static memory",
    "Αργή ανάγνωση": "Slow reading",
    "Μηδενική ταχύτητα εγγραφής": "Zero writing speed",
    "Γραμμική": "Linear",
    "Εκθετική (συνήθως διπλασιασμός)": "Exponential (usually doubling)",
    "Τυχαία": "Random",
    "Μειώνεται": "Decreases",
    "Σχεδιασμός compiler": "Compiler design",
    "Αναπαράσταση γράφων": "Graph representation",
    "Ανάλυση εικόνας": "Image analysis",
    "Διαχείριση αντικειμένων σε game": "Object management in a game",
    "Είναι bug": "It is a bug",
    "Λόγω υπολειπόμενης μνήμης": "Due to residual memory",
    "Για να υπάρχει περιθώριο εισαγών": "To have room for insertions",
    "Για να γίνει realloc": "To perform realloc",
    "Αναδιοργάνωση στοιχείων σε μονοδιάστατο πίνακα": "Reorganization of elements into a one-dimensional array",
    "Αναδιοργάνωση στοιχείων σε πίνακα με δύο διαστάσεις βάσει συγκεκριμένου κριτηρίου": "Reorganization of elements into a two-dimensional array based on a specific criterion",
    "Αντιγραφή δεδομένων από πίνακα σε πίνακα": "Copying data from one array to another",
    "Διαγραφή περιττών στοιχείων": "Deleting unnecessary elements",
    "Τα στοιχεία διαγράφονται": "Elements are deleted",
    "Δημιουργείται ένας νέος μονοδιάστατος πίνακας και ο 2D διαγράφεται": "A new one-dimensional array is created and the 2D is deleted",
    "Τα ταξινομημένα στοιχεία επανατοποθετούνται στον 2D πίνακα": "Sorted elements are repositioned in the 2D array",
    "Ταξινομούνται ξανά ανά στήλη": "They are sorted again by column",
    "Όταν ταξινομούνται ξεχωριστά οι γραμμές": "When rows are sorted separately",
    "Όταν χρησιμοποιούμε επίπεδη μετατροπή και επανατοποθέτηση": "When using flattening conversion and repositioning",
    "Όταν δεν ταξινομούμε καθόλου": "When we do not sort at all",
    "Όταν ταξινομούμε μόνο τις στήλες": "When we sort only the columns",
    "Οι γραμμές έχουν διαφορετικά μεγέθη": "Rows have different sizes",
    "Χρησιμοποιούμε μόνο mergesort": "We use only mergesort",
    "Θέλουμε να ανακατέψουμε τα στοιχεία του πίνακα": "We want to shuffle the array elements",
    "Οι στήλες περιέχουν συγκρίσιμα δεδομένα": "Columns contain comparable data",
    "Άνω τριγωνικός": "Upper triangular (A[i][j] = 0 for i > j)",
    "Διαγώνιος": "Diagonal (A[i][j] = 0 for i != j)",
    "Συμμετρικός": "Symmetric (A[i][j] = A[j][i])",
    "Κάτω τριγωνικός": "Lower triangular (A[i][j] = 0 for i < j)",
    "Στοχαστικό": "Stochastic",
    "Τριγωνικός": "Triangular",
    "Ασύμμετρος": "Asymmetric",
    "Τυχαίος": "Random",
    "Επαναλήψεις": "Repetitions",
    "Αλλαγή ενός διαγώνιου στοιχείου": "Changing a diagonal element",
    "Τυχαία εισαγωγή στοιχείων χωρίς έλεγχο θέσης": "Random insertion of elements without position checking",
    "Αντιγραφή σε νέο πίνακα": "Copying to a new array",
    "Αντιστροφή γραμμών": "Row reversal",
    "Μηδενισμός διαγώνιου στοιχείου": "Zeroing a diagonal element",
    "Εφαρμογή LU decomposition": "Applying LU decomposition",
    "Εισαγωγή στοιχείου μόνο στο A[i][j]": "Inserting an element only at A[i][j]",
    "Περιέχει τουλάχιστον έναν κύκλο": "Contains at least one cycle",
    "Κάθε κόμβος έχει εισερχόμενη και εξερχόμενη ακμή": "Every node has an incoming and outgoing edge",
    "Δεν υπάρχει καμία διαδρομή που επιστρέφει στον αρχικό κόμβο": "There is no path that returns to the starting node (DAG)",
    "Όλες οι ακμές έχουν βάρος": "All edges have weight",
    "Μονής κατεύθυνσης οδικά δίκτυα": "One-way road networks",
    "Ιεραρχία διευθυντών σε μια επιχείρηση": "Hierarchy of managers in a company",
    "Αμοιβαίες φιλίες σε κοινωνικό δίκτυο": "Mutual friendships in a social network",
    "Ροή πληροφορίας σε ένα σύστημα": "Flow of information in a system",
    "O(m * n)": "O(m * n)",
    "O(n * m²)": "O(n * m²)",
    "O(m² * n²)": "O(m² * n²)",
    "O(m * n²)": "O(m * n²)",
    "Η μνήμη δεσμεύεται κατά την εκτέλεση": "Memory is allocated during execution",
    "Ο δείκτης top δείχνει στον τελευταίο κόμβο": "The top pointer points to the last node",
    "Δεν υπάρχει όριο στα δεδομένα που μπορεί να κρατήσει": "There is no limit to the data it can hold",
    "Η εισαγωγή γίνεται στην αρχή της λίστας": "Insertion is done at the beginning of the list",
    "Θα επιστραφεί 0": "0 will be returned",
    "Θα δημιουργηθεί νέος κόμβος": "A new node will be created",
    "Θα προκληθεί σφάλμα (π.χ. NullPointerException)": "An error will be caused (e.g., NullPointerException)",
    "Η στοίβα θα μηδενιστεί": "The stack will be reset to zero",
    "Η ανάγκη ύπαρξης δείκτη στον πρώτο κόμβο": "The need for a pointer to the first node",
    "Η πολυπλοκότητα μνήμης": "Memory complexity",
    "Η ανάγκη εντοπισμού του προτελευταίου κόμβου": "The need to locate the second-to-last node",
    "Δεν είναι δυνατή χωρίς stack": "It is not possible without a stack",

    //PROGRAMMING
    "number": "number",
    "decimal": "decimal",
    "float": "float",
    "textual": "textual",
    "Ακέραιους αριθμούς": "Integer numbers",
    "Κείμενο": "Text",
    "Μόνο λογικές τιμές": "Only boolean values",
    "Έναν χαρακτήρα": "A single character",
    "10": "10",
    "55": "55",
    "25": "25",
    "Τίποτα, θα βγάλει σφάλμα.": "Nothing, it will throw an error.",
    "score@1": "score@1",
    "my-name": "my-name",
    "student__name": "student__name",
    "class": "class",
    "x = '0'": "x = '0'",
    "x = -1": "x = -1",
    "x = 0": "x = 0",
    "x = 'False'": "x = 'False'",
    "4": "4",
    "5": "5",
    "4.0": "4.0",
    "1": "1",
    "<class 'float'>": "<class 'float'>",
    "<class 'int'>": "<class 'int'>",
    "<class 'str'>": "<class 'str'>",
    "<class 'bool'>": "<class 'bool'>",
    "input()": "input()",
    "show()": "show()",
    "print()": "print()",
    "type()": "type()",
    "3": "3",
    "3.14": "3.14",
    "Σφάλμα (Error)": "Error",
    "Η Python δεν ξεχωρίζει πεζά και κεφαλαία": "Python is not case-sensitive",
    "Η input() επιστρέφει πάντα αριθμό": "input() always returns a number",
    "Οι μεταβλητές αποθηκεύουν δεδομένα": "Variables store data",
    "Το % κάνει ακέραια διαίρεση": "% performs integer division",
    "2": "2",
    "3 (Το \"H\", το \"i\" και ο ένας ειδικός χαρακτήρας νέας γραμμής \"\\n\")": "3 (The \"H\", the \"i\" and the one special newline character \"\\n\")",
    "4": "4",
    "Σφάλμα": "Error",
    "name = Nick": "name = Nick",
    "name = 'Nick'": "name = 'Nick'",
    "name = (Nick)": "name = (Nick)",
    "name = <Nick>": "name = <Nick>",
    "T": "T",
    "Y": "Y",
    "Τίποτα / Κενό string": "Nothing / Empty string",
    "TH": "TH",
    "1222": "1222",
    "121212": "121212",
    "7": "7",
    "9": "9",
    "APPLE": "APPLE",
    "apple": "apple",
    "Apple": "Apple",
    "432": "432",
    "4321": "4321",
    "1234": "1234",
    "Κενό string": "Empty string",
    "1ST PLACE": "1ST PLACE",
    "1st place": "1st place",
    "1st Place": "1st Place",
    "1St place": "1St place",
    "['A', 'B', ' ', ' ', 'C']": "['A', 'B', ' ', ' ', 'C']",
    "['A B C']": "['A B C']",
    "['A', 'B', 'C']": "['A', 'B', 'C']",
    "['A', ' ', 'B', ' ', ' ', 'C']": "['A', ' ', 'B', ' ', ' ', 'C']",
    "Μετατρέπει σε κεφαλαία": "Converts to uppercase",
    "Μετατρέπει σε πεζά": "Converts to lowercase",
    "Αντικαθιστά κείμενο": "Replaces text",
    "Μετρά χαρακτήρες": "Counts characters",
    "`‘Hello’ * 0`": "`'Hello' * 0`",
    "`’Hello’[10:]`": "`'Hello'[10:]`",
    "`’Age: ‘ + 25`": "`'Age: ' + 25`",
    "`’word’.find(‘z’)`": "`'word'.find('z')`",
    "Η καθεμία σε δική της γραμμή": "Each on its own line",
    "Κολλητά η μία δίπλα στην άλλη": "Stuck next to each other",
    "Χωρισμένες με κόμμα": "Separated by a comma",
    "Θα πετάξει σφάλμα γιατί δέχεται μόνο strings": "It will throw an error because it only accepts strings",
    "int(line.strip())": "int(line.strip())",
    "line.clean()": "line.clean()",
    "float(line)": "float(line)",
    "line.remove(' ')": "line.remove(' ')",
    "Τις τιμές ('Νίκος', 20)": "The values ('Nikos', 20)",
    "Ολόκληρα τα ζεύγη ('name': 'Νίκος')": "The entire pairs ('name': 'Nikos')",
    "Τα κλειδιά ('name', 'age')": "The keys ('name', 'age')",
    "Το πρόγραμμα θα βγάλει σφάλμα αν δεν υπάρχει η .items()": "The program will throw an error if .items() is not present",
    "Μια λίστα: [0, 2, 4]": "A list: [0, 2, 4]",
    "Ένα λεξικό: {'x': 0, 'x': 2, 'x': 4}": "A dictionary: {'x': 0, 'x': 2, 'x': 4}",
    "Ένα λεξικό: {0: 0, 1: 2, 2: 4}": "A dictionary: {0: 0, 1: 2, 2: 4}",
    "Ένα string: '001224'": "A string: '001224'",
    "Η lambda δεν δέχεται ορίσματα": "Lambda does not accept arguments",
    "Η lambda δεν μπορεί να αποθηκευτεί σε μεταβλητή": "Lambda cannot be stored in a variable",
    "Οι def είναι πιο γρήγορες στην εκτέλεση": "Defs are faster to execute",
    "Η lambda γράφεται αυστηρά σε μία μόνο γραμμή και επιστρέφει το αποτέλεσμα μίας μόνο έκφρασης": "Lambda is written strictly on a single line and returns the result of a single expression",
    "Λίστα": "List",
    "Λεξικό": "Dictionary",
    "Πλειάδα": "Tuple",
    "String": "String",
    "Θα τυπωθεί κανονικά η τιμή της": "Its value will be printed normally",
    "Θα τυπωθεί None": "None will be printed",
    "Η python θα εμφανίσει ένα προειδοποιητικό μήνυμα": "Python will show a warning message",
    "Το πρόγραμμα θα καταρρεύσει με σφάλμα": "The program will crash with an error",
    "del user['password']": "del user['password']",
    "user.pop('password', None)": "user.pop('password', None)",
    "user.remove('password')": "user.remove('password')",
    "Κανένας από τους παραπάνω": "None of the above",
    "Το ίδιο ακριβώς κείμενο με την text1": "Exactly the same text as text1",
    "Ένα κενό string": "An empty string",
    "Σφάλμα, γιατί το αρχείο διαβάστηκε ήδη": "Error, because the file has already been read",
    "Το κείμενο, αλλά γραμμένο ανάποδα": "The text, but written backwards",
    "Η αρχική λίστα θα έχει αλλάξει και θα περιέχει το νέο στοιχείο": "The original list will have changed and will contain the new element",
    "Θα παραμείνει ακριβώς η ίδια, καθώς η συνάρτηση δουλεύει σε αντίγραφο": "It will remain exactly the same, as the function works on a copy",
    "Η Python θα εμφανίσει σφάλμα": "Python will show an error",
    "Η λίστα θα μετατραπεί αυτόματα σε tuple για να προστατευτεί": "The list will automatically be converted to a tuple to be protected",
    "General Usage Instruction": "General Usage Instruction",
    "Graphical User Interface": "Graphical User Interface",
    "Graphic Unit Integration": "Graphic Unit Integration",
    "Generated User Input": "Generated User Input",
    "Ένα σφάλμα (error) που κρασάρει την εφαρμογή": "An error that crashes the application",
    "Το κλείσιμο του παραθύρου": "Closing the window",
    "Μια ενέργεια του χρήστη στην οποία αντιδρά το πρόγραμμα": "A user action to which the program reacts",
    "Ένας κύκλος της λούπας mainloop()": "One cycle of the mainloop() loop",
    "Δημιουργία παραθύρου ➔ mainloop() ➔ Δημιουργία widgets": "Window creation ➔ mainloop() ➔ Widget creation",
    "mainloop() ➔ Δημιουργία παραθύρου ➔ Τοποθέτηση widgets": "mainloop() ➔ Window creation ➔ Widget placement",
    "Τοποθέτηση widgets ➔ Δημιουργία παραθύρου ➔ mainloop()": "Widget placement ➔ Window creation ➔ mainloop()",
    "Δημιουργία παραθύρου ➔ Δημιουργία & τοποθέτηση widgets ➔ mainloop()": "Window creation ➔ Widget creation & placement ➔ mainloop()",
    "Αλλάζει το όνομα του κουμπιού σε 'save'": "Changes the button's name to 'save'",
    "Λέει στο πρόγραμμα να αποθηκεύσει αυτόματα τα δεδομένα": "Tells the program to automatically save the data",
    "Συνδέει το κουμπί με τη συνάρτηση save(), ώστε να εκτελεστεί όταν πατηθεί": "Links the button to the save() function, so it executes when pressed",
    "Ελέγχει αν ο χρήστης έχει δικαίωμα να πατήσει το κουμπί": "Checks if the user has permission to press the button",
    ".grid(row, column)": ".grid(row, column)",
    ".pack()": ".pack()",
    ".place(x, y)": ".place(x, y)",
    "Κανένα από τα παραπάνω.": "None of the above.",
    "tk.StringVar()": "tk.StringVar()",
    "Με μια απλή Python λίστα []": "With a simple Python list []",
    "tk.BooleanVar()": "tk.BooleanVar()",
    "tk.IntVar()": "tk.IntVar()",
    "Είναι μια διεπαφή της Python που επικοινωνεί με την παλαιότερη και ανεξάρτητη γραφική βιβλιοθήκη 'Tk'.": "It is a Python interface that communicates with the older and independent graphical library 'Tk'.",
    "Είναι ένα module γραμμένο καθαρά σε C++ που εκτελείται ανεξάρτητα.": "It is a module written purely in C++ that runs independently.",
    "Είναι μια διαδικτυακή υπηρεσία της Python.": "It is a Python web service.",
    "Είναι ένα εργαλείο σχεδιασμού γραφικών": "It is a graphic design tool",
    "Πρέπει να συνδέσουμε το καθένα με τη δική του, ξεχωριστή tk.StringVar()": "We must link each one to its own, separate tk.StringVar()",
    "Δεν χρειάζονται καθόλου μεταβλητές, το Tkinter το καταλαβαίνει αυτόματα": "No variables are needed at all, Tkinter understands it automatically",
    "Πρέπει να συνδέσουμε όλα τα Radiobuttons της ομάδας με την ίδια tk.StringVar()": "We must link all Radiobuttons of the group to the same tk.StringVar()",
    "Πρέπει να τα συνδέσουμε με τρεις διαφορετικές tk.BooleanVar()": "We must link them to three different tk.BooleanVar()",
    "Το παράθυρο θα ανοίξει κανονικά, αλλά τα κουμπιά δεν θα λειτουργούν": "The window will open normally, but the buttons will not work",
    "Το πρόγραμμα θα τρέξει τις εντολές του και θα τερματίσει αμέσως, χωρίς να προλάβουμε να δούμε κανένα παράθυρο": "The program will run its commands and terminate immediately, without us having time to see any window",
    "Το παράθυρο θα ανοίξει με μαύρο φόντο": "The window will open with a black background",
    "Το πρόγραμμα θα ζητήσει από τον χρήστη να πατήσει Enter στο πληκτρολόγιο": "The program will ask the user to press Enter on the keyboard",
    "Η χρήση της μεθόδου .pack()": "The use of the .pack() method",
    "Δεν μπορούμε να αλλάξουμε τα widgets αφού δημιουργηθούν": "We cannot change the widgets after they are created",
    "Η χρήση της μεθόδου .config()": "The use of the .config() method",
    "Η χρήση της μεθόδου .title()": "The use of the .title() method",
    "True": "True",
    "False": "False",
    "Error": "Error",
    "None": "None",
    "10": "10",
    "error": "error",
    "5": "5",
    "x > 0": "x > 0",
    "x < 20": "x < 20",
    "x == 0": "x == 0",
    "x < 5": "x < 5",
    "True and True": "True and True",
    "False and False": "False and False",
    "True and False": "True and False",
    "1 2 3": "1 2 3",
    "3": "3",
    "0 1 2 3": "0 1 2 3",
    "0 1 2": "0 1 2",
    "0": "0",
    "Error (ZeroDivisionError)": "Error (ZeroDivisionError)",
    "1": "1",
    "Σταματά το loop": "Stops the loop",
    "Παραλείπει το τρέχον βήμα και συνεχίζει": "Skips the current step and continues",
    "Επιστρέφει τιμή": "Returns a value",
    "Δημιουργεί νέα συνθήκη": "Creates a new condition",
    "2": "2",
    "[] (κενή λίστα)": "[] (empty list)",
    "[5, 4, 3, 2, 1, 0]": "[5, 4, 3, 2, 1, 0]",
    "[5, 4, 3, 2, 1]": "[5, 4, 3, 2, 1]",
    "matrix[1, 1] = 99": "matrix[1, 1] = 99",
    "matrix[2][2] = 99": "matrix[2][2] = 99",
    "matrix[1][1] = 99": "matrix[1][1] = 99",
    "matrix[2][1] = 99": "matrix[2][1] = 99",
    "[2]": "[2]",
    "[ ]": "[ ]",
    "[2, 3]": "[2, 3]",
    "IndexError": "IndexError",
    "[5, 8, 9]": "[5, 8, 9]",
    "[5, 2, 8, 9]": "[5, 2, 8, 9]",
    "[5, 8, 2, 2, 9]": "[5, 8, 2, 2, 9]",
    "[5, 8, 2, 9]": "[5, 8, 2, 9]",
    "5": "5",
    "2": "2",
    "6": "6",
    "Σφάλμα": "Error",
    "['a,b,c']": "['a,b,c']",
    "['a', 'b', 'c']": "['a', 'b', 'c']",
    "['a', ',', 'b', ',', 'c']": "['a', ',', 'b', ',', 'c']",
    "['a b c']": "['a b c']",
    "3": "3",
    "1": "1",
    "[1 3]": "[1 3]",
    "['Hello', 'Python']": "['Hello', 'Python']",
    "['H', 'e', 'l', 'l', 'o']": "['H', 'e', 'l', 'l', 'o']",
    "['H', 'P']": "['H', 'P']",
    "Θα εμφανίσει σφάλμα επειδή το word είναι string και όχι λίστα.": "It will display an error because word is a string and not a list.",
    "[3, 2, 1]": "[3, 2, 1]",
    "[1, 2, 3]": "[1, 2, 3]",
    "None": "None",
    "False": "False",
    "Μπορεί να αποθηκεύσει διαφορετικούς τύπους δεδομένων": "It can store different data types",
    "Το μέγεθος της προσαρμόζεται αυτόματα ανάλογα με τη διαθέσιμη μνήμη του συστήματος": "Its size adjusts automatically based on the available system memory",
    "Μπορούμε να τροποποιήσουμε, να προσθέσουμε ή να αφαιρέσουμε στοιχεία της επιτόπου, χωρίς να δημιουργηθεί νέα λίστα": "We can modify, add, or remove its elements in-place, without creating a new list",
    "Μπορούμε να μεταβάλλουμε το όνομα της μεταβλητής κατά τη διάρκεια εκτέλεσης του κώδικα": "We can change the variable name during code execution",
    "Αποτρέπει την εμφάνιση σφαλμάτων IndexError": "Prevents IndexError errors from occurring",
    "Κάνει την προσπέλαση των στοιχείων πιο γρήγορη": "Makes element access faster",
    "Αναγκάζει την Python να μετατρέπει αυτόματα όλα τα στοιχεία σε συμβολοσειρές (strings) για ασφάλεια": "Forces Python to automatically convert all elements into strings for safety",
    "Επιτρέπει την ομαδοποίηση εντελώς διαφορετικών πληροφοριών σε μία μόνο δομή, χωρίς αυστηρούς περιορισμούς": "Allows grouping completely different information into a single structure without strict constraints",
    "Είναι θεμελιώδεις τύποι δεδομένων που δεν διαθέτουν μεθόδους, σε αντίθεση με τα αντικείμενα προσαρμοσμένων κλάσεων": "They are fundamental data types that do not have methods, unlike objects of custom classes",
    "Αποτελούν αντικείμενα ενσωματωμένων κλάσεων και, ως εκ τούτου, διαθέτουν τις δικές τους ιδιότητες και μεθόδους": "They are objects of built-in classes and, therefore, have their own properties and methods",
    "Συμπεριφέρονται ως αντικείμενα μόνο όταν περαστούν ως ορίσματα μέσα στη μέθοδο __init__ μιας νέας κλάσης": "They behave as objects only when passed as arguments within the __init__ method of a new class",
    "Θεωρούνται κλάσεις, αλλά αδυνατούν να δημιουργήσουν αντικείμενα": "They are considered classes, but are unable to create objects",
    "Είναι μια δεσμευμένη λέξη της Python. Οποιαδήποτε αλλαγή του ονόματός της προκαλεί Error": "It is a reserved word in Python. Any change to its name causes an Error",
    "Αποτελεί το πρώτο όρισμα μόνο στις μεθόδους που τροποποιούν Ιδιότητες Κλάσης": "It is the first argument only in methods that modify Class Properties",
    "Λειτουργεί ως γέφυρα με τη γονική κλάση, επιτρέποντας στο αντικείμενο να καλέσει μεθόδους που κληρονόμησε": "It acts as a bridge to the parent class, allowing the object to call methods it inherited",
    "Είναι μια ισχυρή σύμβαση ονοματοδοσίας για την αναφορά στο ίδιο το αντικείμενο": "It is a strong naming convention for referring to the object itself",
    "Κληρονομεί τις ιδιότητες της γονικής, αλλά οι μέθοδοι πρέπει να ξαναγραφτούν απαραίτητα από την αρχή": "It inherits the properties of the parent, but the methods must necessarily be rewritten from scratch",
    "Κληρονομεί τα πάντα και μπορεί να υπερκαλύψει μεθόδους, αλλά απαγορεύεται να προσθέσει εντελώς νέα χαρακτηριστικά": "It inherits everything and can override methods, but it is forbidden to add entirely new features",
    "Κληρονομεί αυτόματα τις μεθόδους και ιδιότητες, μπορεί να εξειδικεύσει τη συμπεριφορά της και έχει τη δυνατότητα να προσθέσει ολότελα νέα χαρακτηριστικά": "It automatically inherits methods and properties, can specialize its behavior, and has the ability to add entirely new features",
    "Κληρονομεί μόνο τις μεθόδους που έχουν τη λέξη-κλειδί @abstractmethod στη γονική κλάση": "It inherits only the methods that have the @abstractmethod keyword in the parent class",
    "Αναζητά τη μέθοδο πρώτα στην κλάση του ίδιου του αντικειμένου. Αν τη βρει, σταματάει εκεί, αλλιώς ανεβαίνει στη γονική": "It looks for the method first in the object's own class. If it finds it, it stops there, otherwise it goes up to the parent",
    "Ψάχνει πρώτα στη γονική κλάση. Αν τη βρει, αγνοεί την υλοποίηση της παιδικής κλάσης": "It looks first in the parent class. If it finds it, it ignores the child class implementation",
    "Εκτελεί ταυτόχρονα και τις δύο μεθόδους (γονική και παιδική) συνενώνοντας τα αποτελέσματά τους": "It executes both methods (parent and child) simultaneously, merging their results",
    "Διαγράφει την παλιά μέθοδο και κρατάει μόνιμα μόνο αυτή της παιδικής κλάσης για όλα τα μελλοντικά αντικείμενα": "It deletes the old method and permanently keeps only the one from the child class for all future objects",
    "Η κλάση δημιουργεί αντικείμενα πολύ πιο γρήγορα στη μνήμη, επειδή παραλείπει τη μέθοδο __init__": "The class creates objects much faster in memory because it skips the __init__ method",
    "Η κλάση αυτή λειτουργεί ως αυστηρό συμβόλαιο, απαγορεύει τη δημιουργία δικών της στιγμιοτύπων και αναγκάζει τις υποκλάσεις να υλοποιήσουν συγκεκριμένες μεθόδους": "This class acts as a strict contract, forbids the creation of its own instances, and forces subclasses to implement specific methods",
    "Οι υποκλάσεις της χάνουν το δικαίωμα της κληρονομικότητας και αποκτούν μόνο τις ιδιότητες κλάσης": "Its subclasses lose the right of inheritance and acquire only the class properties",
    "Η αφηρημένη μέθοδος εκτελείται αυτόματα μέσα στη super() της παιδικής κλάσης χωρίς να χρειαστεί να υλοποιηθεί ξανά": "The abstract method is automatically executed within the super() of the child class without having to be implemented again",
    "Συγχωνεύει δύο διαφορετικές κλάσεις σε μία, αρκεί να έχουν τις ίδιες ακριβώς ιδιότητες στιγμιοτύπου": "Merges two different classes into one, as long as they have the exact same instance properties",
    "Αλλάζει αυτόματα το όνομα των μεθόδων ώστε να ταιριάζουν με τις απαιτήσεις του super()": "Automatically changes method names to match the requirements of super()",
    "Δίνει τη δυνατότητα σε μια γονική κλάση να μετατρέπεται σε πολλές διαφορετικές υποκλάσεις την ώρα της εκτέλεσης": "Enables a parent class to transform into many different subclasses at runtime",
    "Επιτρέπει να αντιμετωπίζουμε αντικείμενα εντελώς διαφορετικών κλάσεων με κοινό τρόπο, εφόσον μοιράζονται μεθόδους με ίδιο όνομα ή αντίστοιχη λογική": "Allows us to treat objects of entirely different classes in a common way, as long as they share methods with the same name or similar logic",
    "4": "4",
    "3": "3",
    "Σφάλμα": "Error",
    "Κενό": "Empty",
    "Θα εκτελεστεί μόνο η speak() της Animal": "Only the speak() method of Animal will execute",
    "Θα εκτελεστούν και οι δύο μεθόδοι ταυτόχρονα": "Both methods will execute simultaneously",
    "Θα εκτελεστεί μόνο η speak() της Dog": "Only the speak() method of Dog will execute",
    "Η Python θα πετάξει σφάλμα λόγω σύγκρουσης ονομάτων": "Python will throw an error due to a name conflict",
    "Την ίδια την κλάση": "The class itself",
    "Μια δεσμευμένη λέξη της Python που απαγορεύεται να αλλάξει": "A reserved Python word that is forbidden to change",
    "Την ταχύτητα που περνάμε": "The speed we are passing",
    "Το συγκεκριμένο αντικείμενο που καλεί τη μέθοδο εκείνη τη στιγμή": "The specific object calling the method at that moment",
    "Χρησιμοποιώντας το πρόθεμα: private self.password": "Using the prefix: private self.password",
    "Προσθέτοντας κάτω παύλες: self._password ή self.__password": "By adding underscores: self._password or self.__password",
    "Αφαιρώντας απλώς το self από μπροστά": "Simply by removing the self from the front",
    "Κλειδώνοντάς την μέσα στην super()": "By locking it within super()",
};